{
  "a11y": {
    "home": "Dubai To-Do — home",
    "menu": "Menu",
    "closeMenu": "Close menu",
    "search": "Search",
    "language": "Language: {{name}}",
    "mainNav": "Main",
    "categories": "Categories",
    "open": "Open {{title}}",
    "breadcrumb": "Breadcrumb",
    "saved": "Saved",
    "account": "Account",
    "save": "Save {{title}}"
  },
  "nav": {
    "tours": "Tours",
    "boats": "Yachts & Boats",
    "desert": "Desert",
    "attractions": "Attractions",
    "dayTrips": "Day Trips",
    "home": "Home",
    "events": "Events",
    "guides": "Guides",
    "hotels": "Where to stay"
  },
  "home": {
    "metaTitle": "Things to Do in Dubai — Desert Safaris, Tours & Cruises",
    "metaDescription": "Things to do in Dubai, ranked by real reviews: desert safaris, city tours, dhow cruises, Burj Khalifa tickets, balloon flights and day trips to Abu Dhabi.",
    "heroTitle": "Dubai Tours & Things to Do",
    "heroLead": "Desert safaris, dhow cruises and balloon flights — ranked by real reviews.",
    "featuredTitle": "Featured This Week",
    "featuredEyebrow": "Handpicked experiences worth your time",
    "viewAllExperiences": "View all experiences",
    "moodTitle": "Curated for Your Mood",
    "moodEyebrow": "Discover handpicked ideas for any occasion",
    "heroAlt": "Dubai skyline at sunset seen from a waterfront terrace",
    "guideTitle": "Things to Do in Dubai by Category",
    "guidesTitle": "From our Dubai guides",
    "guidesEyebrow": "Itineraries, seasons and tips for planning your trip",
    "guideCount_one": "{{count}} experience",
    "guideCount_other": "{{count}} experiences",
    "guide": {
      "desert-safari": {
        "text": "The classic Dubai experience: dune bashing in a 4×4, quad bikes and sandboarding, a camel ride and a barbecue dinner at a desert camp. Pick an evening safari for the sunset and shows, a morning one for cooler, quieter dunes, or an overnight trip under the stars.",
        "link": "Browse desert safaris"
      },
      "city-tours": {
        "text": "A Dubai city tour covers the highlights in a half or full day: Al Fahidi and the gold and spice souks, an abra across Dubai Creek, Jumeirah Mosque and photo stops at the Burj Al Arab, the Palm and Dubai Frame.",
        "link": "Browse city tours"
      },
      "attractions": {
        "text": "Tickets for the Burj Khalifa observation decks, Dubai Frame, Museum of the Future, Dubai Aquarium and the theme parks — book a timed slot ahead and skip the queue at the busiest sights.",
        "link": "Browse attraction tickets"
      },
      "water-sports": {
        "text": "Jet ski rides past the Burj Al Arab and Atlantis, parasailing over the Marina, flyboarding, snorkelling and diving — the Gulf is warm enough for water sports most of the year.",
        "link": "Browse jet ski tours & water sports"
      },
      "dhow-cruise": {
        "text": "A dhow dinner cruise is one of the easiest evenings in Dubai: a traditional wooden boat, a buffet and live shows, on Dubai Creek past the old souks or in Dubai Marina among the towers.",
        "link": "Browse dhow cruises"
      },
      "family": {
        "text": "Things to do in Dubai with kids: water parks and theme parks, aquariums, gentle cruises and desert trips that suit children as well as adults.",
        "link": "Browse family activities"
      },
      "day-trips": {
        "text": "Abu Dhabi is about 90 minutes away, with the Sheikh Zayed Grand Mosque, Louvre Abu Dhabi and Yas Island. Or head for the mountains of Hatta, or the fjords of Musandam in Oman (bring your passport).",
        "link": "Browse Abu Dhabi tours & day trips"
      },
      "scenic-flights": {
        "text": "Dubai from the air: a hot-air balloon over the desert at sunrise, often with breakfast and a falconry show, or a helicopter tour past Burj Khalifa, the Palm and the Marina.",
        "link": "Browse scenic flights"
      }
    },
    "tipsTitle": "Good to Know Before You Go",
    "tipsEyebrow": "Plan your days in Dubai",
    "tips": {
      "season": {
        "title": "Best time to visit",
        "text": "November to March brings warm, sunny days and pleasant evenings — peak season for safaris, cruises and beach days. From June to September it often passes 40 °C: plan desert trips for early morning or evening and keep middays for indoor attractions."
      },
      "customs": {
        "title": "Local customs",
        "text": "Dress modestly in mosques, souks and the old town: shoulders and knees covered, and a headscarf for women at the Sheikh Zayed Grand Mosque. During Ramadan most tours still run, sometimes at other times, and evenings come alive after iftar."
      },
      "booking": {
        "title": "Booking & pickup",
        "text": "Popular safaris, sunset cruises and Burj Khalifa slots sell out in high season, so book ahead. Many experiences include hotel pickup and free cancellation up to 24 hours before — each listing shows its own terms."
      },
      "ranking": {
        "title": "How we rank",
        "text": "Not by stars alone: a 5.0 from three reviews says little, so we weigh each rating by its number of reviews. Tours come from Viator, yacht and boat trips from Click&Boat; you book on the partner's site, and we may earn a commission at no extra cost to you."
      }
    },
    "faqTitle": "Frequently Asked Questions",
    "faqEyebrow": "Things to do in Dubai, answered",
    "faq": {
      "mustDo": {
        "q": "What are the must-do things in Dubai for first-time visitors?",
        "a": "An evening desert safari, the Burj Khalifa observation deck, a dhow cruise on Dubai Creek or in Dubai Marina, a walk through the old souks with an abra ride across the Creek, and a day at the beach or on the water off Palm Jumeirah. With an extra day, add a trip to Abu Dhabi."
      },
      "safari": {
        "q": "Which desert safari should I choose?",
        "a": "The evening safari is the most popular: dune bashing, a camel ride, sandboarding and a barbecue dinner with shows at a desert camp. A morning safari is shorter and cooler, an overnight safari adds a night under the stars, and quad bikes or dune buggies let you drive yourself. With small children or back problems, pick a safari without dune bashing."
      },
      "flights": {
        "q": "Is a hot-air balloon or helicopter ride in Dubai worth it?",
        "a": "For many travellers it is the highlight of the trip. Balloons take off over the desert at sunrise, so pickup is very early, before dawn, and most packages add breakfast at a desert camp. Helicopter tours start at about 12 minutes and fly past Burj Khalifa, the Burj Al Arab, the Palm and the Marina."
      },
      "advance": {
        "q": "Should I book tours in Dubai in advance?",
        "a": "Yes, especially from November to March and around holidays, when popular safaris, sunset cruises and Burj Khalifa time slots sell out. Booking ahead also fixes the price, and many experiences can still be cancelled for free."
      },
      "cancel": {
        "q": "Can I cancel a booking?",
        "a": "Many experiences offer free cancellation up to 24 hours before the start. The exact policy depends on the tour and is shown on the partner's page before you pay."
      },
      "wear": {
        "q": "What should I wear for tours in Dubai?",
        "a": "Light, breathable clothes, a hat and sunscreen. Cover shoulders and knees for mosques, souks and the old town; women also need a headscarf at the Sheikh Zayed Grand Mosque. In the desert closed shoes beat sandals, and winter evenings can call for a light jacket."
      },
      "kids": {
        "q": "Is Dubai good for families with children?",
        "a": "Very. Water parks, theme parks, aquariums, gentle cruises and family-friendly desert trips make it easy to plan for every age. Many tours have child prices; check the minimum age, especially for dune bashing and water sports."
      },
      "abuDhabi": {
        "q": "Can I visit Abu Dhabi on a day trip from Dubai?",
        "a": "Yes. Abu Dhabi is about 90 minutes away by road. Guided day trips usually include the Sheikh Zayed Grand Mosque and add the Louvre Abu Dhabi, Qasr Al Watan or the theme parks of Yas Island, with pickup from your hotel in Dubai."
      },
      "newYear": {
        "q": "What is there to do on New Year's Eve in Dubai?",
        "a": "Watch the fireworks over the Burj Khalifa, the Palm or the Marina, go to a gala dinner or a beach-club party, or see midnight from a dhow or yacht cruise. Our New Year's Eve page lists the season's parties and cruises, with tips on road closures and the metro."
      },
      "booking": {
        "q": "Do I book through Dubai To-Do?",
        "a": "We help you compare experiences; the booking itself happens on our partner's site — Viator for tours, Click&Boat for yacht and boat trips — under its terms, with its payment and customer support. When you book through our links we may earn a commission, at no extra cost to you."
      }
    },
    "eventsTitle": "Events This Week",
    "eventsEyebrow": "Brunches, comedy, concerts and more in the next 7 days",
    "viewAllEvents": "View all events",
    "nyeTitle": "New Year's Eve in Dubai",
    "nyeEyebrow": "Parties, gala dinners and cruises for 31 December",
    "nyeMore": "New Year's Eve guide"
  },
  "search": {
    "label": "What are you looking for?",
    "placeholder": "What are you looking for?",
    "submit": "Search",
    "landmark": "Search Dubai To-Do",
    "searchFor": "Search for “{{query}}”",
    "categories": "Categories",
    "popularTitle": "Popular searches",
    "suggestions": "Suggestions",
    "popular": [
      {
        "label": "Burj Khalifa",
        "q": "burj khalifa"
      },
      {
        "label": "Abu Dhabi",
        "q": "abu dhabi"
      },
      {
        "label": "Hot air balloon",
        "q": "balloon"
      },
      {
        "label": "Helicopter tour",
        "q": "helicopter"
      },
      {
        "label": "Jet ski",
        "q": "jet ski"
      },
      {
        "label": "Quad bike",
        "q": "quad"
      },
      {
        "label": "Dubai Marina",
        "q": "marina"
      },
      {
        "label": "Dinner cruise",
        "q": "dinner"
      },
      {
        "label": "Private tour",
        "q": "private"
      },
      {
        "label": "Dubai Frame",
        "q": "frame"
      }
    ]
  },
  "strip": {
    "boats": "Yachts &\nCruises"
  },
  "collections": {
    "desert-safari": {
      "title": "Desert Safaris",
      "short": "Desert\nSafaris",
      "intro": "Dune bashing in a 4×4, camel rides, sandboarding and dinner at a desert camp under the stars — the classic way to see the dunes outside the city.",
      "meta": "Book a desert safari in Dubai: evening safaris with BBQ dinner and shows, morning dune bashing, quad bikes, camel rides and overnight desert camps.",
      "metaFrom": "Desert safari Dubai from {{price}}: evening safaris with BBQ dinner and shows, morning dune bashing, private and VIP safaris, quad bikes and overnight camps.",
      "seoTitle": "Desert Safari Dubai: Evening, Morning & Overnight",
      "heading": "Desert Safari in Dubai",
      "guideTitle": "Choosing your Dubai desert safari",
      "guide": [
        {
          "h": "Evening, morning or overnight?",
          "p": [
            "The evening desert safari is the classic: pickup from your hotel in the early afternoon, dune bashing in a 4×4, a stop for sunset photos, then a desert camp with a camel ride, sandboarding, henna, a barbecue dinner and live shows such as tanoura and fire dancing. You are usually back in the city by around 9 pm.",
            "A morning safari is shorter and cooler, with fewer crowds on the dunes — ideal if your evenings are already booked. An overnight safari adds a night at a camp under the stars and breakfast in the desert."
          ]
        },
        {
          "h": "Dune bashing, quad bikes and dune buggies",
          "p": [
            "Dune bashing means an experienced driver takes your 4×4 up and over the dunes at speed — thrilling, but bumpy. If you prefer to drive yourself, add a quad bike or a dune buggy session in the red dunes of Lahbab, or choose a private safari with a vehicle just for your group.",
            "For a gentler day, look for safaris in the Al Marmoom conservation area, which focus on wildlife, vintage Land Rovers and falconry rather than adrenaline.",
            "On a shared safari you ride in a 4×4 with other guests, usually six to a car, and share the camp with other groups. A private safari keeps the car and driver for your group alone, with your own pickup time and pace; VIP and luxury packages add a smaller camp, table service instead of a buffet queue, or a drive in a vintage Land Rover."
          ]
        },
        {
          "h": "What to bring and how to book",
          "p": [
            "Wear light, covering clothes and closed shoes or sandals you don't mind filling with sand, and bring sunglasses, sunscreen and a light layer for the evening — winter nights in the desert are cool.",
            "Compare what each tour includes: hotel pickup, the type of camp, dinner (BBQ, vegetarian options), soft drinks and extras such as quad bikes. Most safaris here can be cancelled free of charge up to 24 hours before, and the list is ranked by reviews, so the most consistently rated tours come first."
          ]
        }
      ],
      "faq": [
        {
          "q": "Morning or evening desert safari — which is better?",
          "a": "The evening safari is the full experience: dune bashing, the sunset and a camp with barbecue dinner and shows. The morning safari is shorter and cooler, with the dunes and the activities but no camp. Choose the evening for the camp, the morning if your evenings are booked."
        },
        {
          "q": "How long does an evening desert safari in Dubai take?",
          "a": "Around six to seven hours including hotel pickup and drop-off: you leave in the afternoon, spend roughly 30–45 minutes dune bashing, watch the sunset and spend the evening at the camp with dinner and shows."
        },
        {
          "q": "Is dune bashing safe for children and pregnant women?",
          "a": "Dune bashing is not recommended during pregnancy, for people with back or heart problems, or for very small children. Most operators offer the camp and camel ride without the dune drive — choose a safari without dune bashing or a wildlife safari instead."
        },
        {
          "q": "What is the best time of year for a desert safari?",
          "a": "October to April, when days are warm and evenings in the desert are pleasant. Safaris run all year, but from June to September a morning or evening trip is the only comfortable option."
        },
        {
          "q": "Is dinner included in a desert safari?",
          "a": "On evening and overnight safaris, usually yes — a buffet or barbecue dinner at the camp with soft drinks, tea and coffee. Check the tour's inclusions for vegetarian options and whether alcohol is available."
        },
        {
          "q": "What should I wear on a desert safari?",
          "a": "Light, loose clothes that cover the shoulders and knees, closed shoes or sandals you don’t mind filling with sand, sunglasses and a scarf against the dust. From November to March bring a jacket or sweater: the desert cools down fast after sunset. Women don’t need to cover their hair."
        },
        {
          "q": "Private, VIP or shared safari?",
          "a": "A shared safari is the classic, with other guests in the car and at the camp. A private safari gives your group its own car, driver and timing. VIP and luxury packages add a quieter camp, table service and extras such as falconry — each listing says what is included."
        },
        {
          "q": "How much does a desert safari in Dubai cost?",
          "a": "It depends on the type: shared evening safaris are the cheapest, private, VIP and overnight safaris cost several times more, and quad bikes or buggies are often an extra. Each card shows the current price, so you can compare like for like."
        },
        {
          "q": "Where does a Dubai desert safari take place?",
          "a": "In the red dunes south-east of the city, mostly around Lahbab and Al Badayer, about 45 minutes to an hour by car from Downtown or Dubai Marina; conservation safaris go to the Al Marmoom reserve. Most tours pick you up at your hotel, so you don’t need the address."
        }
      ]
    },
    "city-tours": {
      "title": "City Tours",
      "short": "City\nTours",
      "intro": "Guided ways into Dubai, from the souks and wind towers of the old town to the skyline of Downtown and the Palm.",
      "meta": "Guided Dubai city tours: Al Fahidi, the gold and spice souks, an abra ride on Dubai Creek, Jumeirah Mosque, Burj Khalifa, Dubai Frame and the Palm.",
      "seoTitle": "Dubai City Tours: Old Dubai, Downtown & the Palm",
      "heading": "Dubai City Tours",
      "guideTitle": "Seeing Dubai on a city tour",
      "guide": [
        {
          "h": "Old Dubai and Dubai Creek",
          "p": [
            "Most city tours start where Dubai began: the Al Fahidi historical district with its wind towers, coral-stone houses and small museums, then an abra — a traditional wooden water taxi — across Dubai Creek to Deira's gold and spice souks.",
            "This part of the city is best on foot with a guide who can explain the trading history, the pearl diving and how the town looked before oil."
          ]
        },
        {
          "h": "Modern Dubai: Downtown, Jumeirah and the Palm",
          "p": [
            "The modern half of a typical tour covers photo stops at Jumeirah Mosque, the Burj Al Arab, Palm Jumeirah and Atlantis, Dubai Frame and Downtown with Burj Khalifa and The Dubai Mall. Some tours include the Burj Khalifa observation deck or a ride on the Palm Monorail.",
            "Half-day tours fit either the old or the new city; a full-day tour covers both, usually with lunch."
          ]
        },
        {
          "h": "Group, private or by bus?",
          "p": [
            "Small-group tours are the easiest way to see the highlights with a guide. A private tour lets you set the pace and the stops — useful with children or for photography. Hop-on hop-off buses, food tours and evening tours are good alternatives if you prefer to explore at your own rhythm.",
            "Hotel pickup is included on most guided tours. The list is ranked by reviews, with free cancellation on most tours up to 24 hours before."
          ]
        }
      ],
      "faq": [
        {
          "q": "How long is a Dubai city tour?",
          "a": "Half-day tours take about four to five hours and cover either old Dubai or the modern city. Full-day tours take seven to eight hours and combine both, often with a lunch stop."
        },
        {
          "q": "Is there a dress code for visiting mosques in Dubai?",
          "a": "Yes: shoulders and knees covered for everyone, and women cover their hair at Jumeirah Mosque or the Grand Mosque in Abu Dhabi. Tours visiting a mosque usually tell you in advance, and some mosques lend abayas at the entrance."
        },
        {
          "q": "Can I combine a city tour with Burj Khalifa?",
          "a": "Yes. Some city tours include an At the Top ticket; otherwise book a timed Burj Khalifa ticket for the end of the tour — sunset slots are the most popular and sell out first."
        },
        {
          "q": "Are city tours in Dubai suitable for summer?",
          "a": "Yes, as long as you choose a tour in an air-conditioned vehicle with short walks. From June to September, morning or evening tours are much more comfortable than the middle of the day."
        }
      ]
    },
    "attractions": {
      "title": "Attractions & Tickets",
      "short": "Attractions\n& Tickets",
      "intro": "Observation decks, theme parks, aquariums and museums — tickets for Dubai's best-known sights in one list.",
      "meta": "Tickets for Dubai's top attractions: Burj Khalifa At the Top, Dubai Frame, Museum of the Future, Dubai Aquarium, water parks and theme parks.",
      "seoTitle": "Dubai Attractions Tickets: Burj Khalifa & More",
      "heading": "Dubai Attractions & Tickets",
      "guideTitle": "Booking tickets for Dubai's attractions",
      "guide": [
        {
          "h": "Observation decks and landmarks",
          "p": [
            "Burj Khalifa's At the Top decks on levels 124 and 125 are the best-known view in the city; the higher SKY deck on level 148 adds a lounge and fewer people. Dubai Frame looks over old and new Dubai from a glass bridge, and the Museum of the Future combines striking architecture with immersive exhibitions.",
            "Timed tickets are sold per slot, and sunset slots at Burj Khalifa often sell out days ahead — book early and arrive a little before your time."
          ]
        },
        {
          "h": "Aquariums, water parks and theme parks",
          "p": [
            "Dubai Aquarium & Underwater Zoo in The Dubai Mall and The Lost Chambers at Atlantis are easy half-days with children. For a full day, Aquaventure, the water park on the Palm, and the indoor theme parks are among the most popular tickets in the city.",
            "Indoor attractions are the best plan for the hottest months, from June to September."
          ]
        },
        {
          "h": "How to save time and money",
          "p": [
            "Booking ahead fixes the price and your time slot, and lets you skip the ticket queues at the busiest sights. Combo tickets — Burj Khalifa with the aquarium, for example — usually cost less than buying each one separately.",
            "Check each ticket for what it includes, age categories and whether it can be cancelled. The list is ranked by reviews, so the most consistently rated attractions come first."
          ]
        }
      ],
      "faq": [
        {
          "q": "Should I book Burj Khalifa tickets in advance?",
          "a": "Yes. Tickets are sold for a specific time, and prices at the door are often higher. Sunset slots sell out first, especially from November to March and on weekends."
        },
        {
          "q": "Which Burj Khalifa ticket should I choose?",
          "a": "At the Top (levels 124 and 125) is enough for most visitors. At the Top SKY (level 148) costs more but is less crowded and includes a lounge with refreshments."
        },
        {
          "q": "What are the best attractions in Dubai for a rainy or very hot day?",
          "a": "Indoor sights: Museum of the Future, Dubai Aquarium & Underwater Zoo, The Lost Chambers, the indoor theme parks and the observation decks, which are all fully air-conditioned."
        },
        {
          "q": "Are there discounts for children?",
          "a": "Most attractions have child tickets, and small children often go free; the age limits differ from one attraction to the next, so check each ticket's conditions before you book."
        }
      ]
    },
    "water-sports": {
      "title": "Jet Ski & Water Sports",
      "short": "Water\nSports",
      "intro": "Jet ski tours past the Burj Al Arab, Atlantis and the Marina skyline — plus parasailing, flyboarding and diving in the warm waters of the Gulf.",
      "meta": "Jet ski Dubai: guided jet ski tours past the Burj Al Arab, Atlantis and Palm Jumeirah, plus parasailing, flyboarding, snorkelling and diving.",
      "metaFrom": "Jet ski Dubai from {{price}}: guided jet ski tours past the Burj Al Arab, Atlantis and Palm Jumeirah, plus parasailing, flyboarding, snorkelling and diving.",
      "seoTitle": "Jet Ski Dubai: Jet Ski Tours & Water Sports",
      "heading": "Jet Ski & Water Sports in Dubai",
      "guideTitle": "Water sports in Dubai: what to expect",
      "guide": [
        {
          "h": "Jet ski tours: routes and durations",
          "p": [
            "A jet ski tour is the most popular way to see Dubai from the water. The length decides the route: a 30-minute ride usually goes out to the Burj Al Arab for photos; an hour adds Atlantis The Palm and the outer crescent of Palm Jumeirah; tours of 90 minutes to two hours continue to Dubai Marina, JBR and the Ain Dubai wheel.",
            "Tours leave from Dubai Harbour and the Marina, from Jumeirah near the Burj Al Arab, and from the Palm. Many have stops for photos with the skyline behind you — the guide usually takes them."
          ]
        },
        {
          "h": "Guided tour or rental, alone or two up",
          "p": [
            "In Dubai a jet ski goes out with a guide: the group follows a lead rider along the coast, which is required outside the marked rental zones. No licence is needed; you get a safety briefing and a life jacket before you start.",
            "Most jet skis take two people, so couples and parents with a child often share one — the passenger rides behind the driver. Drivers usually have to be 16 or over; the listing gives the operator’s age limits."
          ]
        },
        {
          "h": "Parasailing, flyboarding and more",
          "p": [
            "Parasailing lifts you high above the beach and Dubai Marina, solo or in tandem. Flyboarding and hoverboarding use the power of a water jet to lift you above the surface — an instructor stays with you the whole time. Banana boats, wakeboarding and stand-up paddle are easy add-ons for groups and families."
          ]
        },
        {
          "h": "Snorkelling and diving",
          "p": [
            "The Gulf is calm and warm, with reefs and wrecks off the coast and clearer water on the east coast at Fujairah and in Musandam. Discover-scuba sessions suit beginners with no certification; certified divers can book guided dives.",
            "Water temperatures stay above 20°C even in winter and reach the low 30s in summer, so water sports run all year — in summer, go early in the morning."
          ]
        }
      ],
      "faq": [
        {
          "q": "How long is a jet ski tour in Dubai?",
          "a": "From 30 minutes to two hours. Thirty minutes is enough for the Burj Al Arab, an hour adds Atlantis and the Palm, and longer tours reach Dubai Marina and Ain Dubai."
        },
        {
          "q": "How much does a jet ski ride in Dubai cost?",
          "a": "It depends on the length of the ride and on whether the price is per jet ski (one or two riders) or per person: the 30-minute ride to the Burj Al Arab is the cheapest, hour-long tours to Atlantis and the Marina cost more. Each card shows the current price."
        },
        {
          "q": "Where do jet ski tours to the Burj Al Arab start?",
          "a": "Most from Dubai Harbour and Dubai Marina, some from the Jumeirah beaches close to the hotel. Thirty minutes is enough to ride out, stop for photos in front of the Burj Al Arab and come back. The listing names the meeting point."
        },
        {
          "q": "Can I ride a jet ski around Palm Jumeirah and Atlantis?",
          "a": "Yes, on tours of an hour or more: they follow the outer crescent of the Palm to Atlantis The Palm, usually with the Burj Al Arab on the same ride. Tours from Dubai Harbour or the Palm itself get there fastest."
        },
        {
          "q": "Can two people ride one jet ski?",
          "a": "Yes, most jet skis are two-seaters: one person drives, the other rides behind. The price in the listing says whether it is per jet ski or per person."
        },
        {
          "q": "What is the minimum age for a jet ski in Dubai?",
          "a": "Drivers must be 16 or over. Children can ride behind an adult as passengers — from about 6 years on many tours, older on some; the listing gives the operator’s limit."
        },
        {
          "q": "Do I need a licence to ride a jet ski in Dubai?",
          "a": "No, not for a guided jet ski tour: the operator gives you a briefing and a guide leads the ride. Riders usually need to be at least 16 to drive alone; younger children can ride as passengers with an adult."
        },
        {
          "q": "Can I do water sports if I can't swim?",
          "a": "For parasailing, jet ski rides and banana boats you always wear a life jacket, so strong swimming isn't required. For flyboarding, snorkelling and diving, you should be comfortable in the water."
        },
        {
          "q": "What is the best time of day for water sports in Dubai?",
          "a": "Morning, when the sea is calmest and the heat is lower. Late afternoon is beautiful for photos of the skyline, but the wind often picks up."
        },
        {
          "q": "Where do water sports start in Dubai?",
          "a": "Most activities start from Dubai Marina, JBR beach, Jumeirah and the Palm. Check the meeting point on each tour — some include transfers from your hotel, others don't."
        }
      ]
    },
    "dhow-cruise": {
      "title": "Dhow Cruises",
      "short": "Dhow\nCruises",
      "intro": "Traditional wooden dhows on Dubai Creek or along the Marina, most of them with dinner on board as the city lights up.",
      "meta": "Dhow cruises in Dubai: dinner cruises on Dubai Creek and in Dubai Marina aboard traditional wooden boats, with buffet, live shows and city views.",
      "metaFrom": "Dhow cruise Dubai from {{price}}: dinner cruises on Dubai Creek and in Dubai Marina aboard traditional wooden boats, with buffet, live shows and city views.",
      "seoTitle": "Dhow Cruise Dubai: Dinner Cruises on Creek & Marina",
      "heading": "Dhow Cruises in Dubai",
      "guideTitle": "Choosing a dhow cruise in Dubai",
      "guide": [
        {
          "h": "Dubai Creek or Dubai Marina?",
          "p": [
            "A Dubai Creek cruise takes you past the old town: the souks of Deira, Al Fahidi's wind towers and the abras crossing the water — the more traditional, historic setting. A Dubai Marina cruise glides between illuminated skyscrapers and out towards Palm Jumeirah — the modern skyline at night.",
            "Both last about two hours. If it's your first evening in Dubai, the Marina is the more spectacular; if you've seen the towers, the Creek is the more atmospheric."
          ]
        },
        {
          "h": "What a dinner cruise includes",
          "p": [
            "Most dhow cruises include an international and Arabic buffet, soft drinks, water, tea and coffee, and live entertainment such as a tanoura dance. Seating is usually on an open upper deck and an air-conditioned lower deck — choose the upper deck in winter for the views.",
            "Some cruises include hotel transfers; others meet at the pier. Alcohol is served only on licensed boats, so check if it matters to you."
          ]
        },
        {
          "h": "Beyond the classic dinner dhow",
          "p": [
            "Look out for sunset dhow cruises, premium dhows with fewer guests and set menus, and private dhows for families, birthdays and groups.",
            "Some Creek cruises continue into the Dubai Water Canal, through Business Bay towards the Burj Khalifa skyline; a few Marina cruises sail out to the Palm and Ain Dubai. The listing gives the route."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is a dhow cruise?",
          "a": "A dhow is the traditional wooden boat of the Gulf, once used for trade and pearl diving. In Dubai the dhows are now floating restaurants: a two-hour evening cruise with dinner, music and the city lights from the deck."
        },
        {
          "q": "How long does a dhow cruise in Dubai last?",
          "a": "Usually about two hours on the water, with boarding 30 minutes before departure. Most dinner cruises start between 7:30 and 8:30 pm."
        },
        {
          "q": "Is a dhow cruise suitable for children?",
          "a": "Yes, it's one of the easiest evenings for families: the boats are calm, there is a buffet, and children usually pay a reduced price. Keep small children close on the open deck."
        },
        {
          "q": "What should I wear on a dhow cruise?",
          "a": "Smart-casual clothes. In winter bring a light jacket for the open deck; in summer the lower deck is air-conditioned."
        },
        {
          "q": "Which dhow cruise is the best?",
          "a": "It depends on what you want to see: the Marina for modern towers, the Creek for old Dubai. The list is ranked by traveller reviews, so the most consistently rated cruises come first."
        },
        {
          "q": "Is a Marina cruise the same as a dhow cruise?",
          "a": "Often, yes: a Marina dhow cruise is a dhow cruise in Dubai Marina. Some Marina dinner cruises use a modern glass-roofed boat or a yacht instead of a wooden dhow — the listing says which boat it is."
        },
        {
          "q": "Is alcohol served on a dhow cruise?",
          "a": "Only on licensed boats, which are few — mostly in Dubai Marina. The classic dinner cruises serve soft drinks, water, tea and coffee; check the inclusions if it matters to you."
        },
        {
          "q": "How do I book a dhow cruise?",
          "a": "Online, for the date you want: the dinner cruises fill up on weekends and in the winter season. Choose the Creek or the Marina, check whether the hotel transfer is included, and keep the confirmation for boarding."
        }
      ]
    },
    "family": {
      "title": "Family",
      "short": "Family",
      "intro": "Days out that work for children and adults alike — water parks, aquariums, gentle cruises and hands-on experiences.",
      "meta": "Things to do in Dubai with kids: water parks and theme parks, aquariums, family desert safaris, dhow cruises and hands-on activities for all ages.",
      "seoTitle": "Things to Do in Dubai with Kids: Family Activities",
      "heading": "Things to Do in Dubai with Kids",
      "guideTitle": "Planning a family trip to Dubai",
      "guide": [
        {
          "h": "Days out for every age",
          "p": [
            "Dubai is one of the easiest cities in the world to visit with children. Water parks, aquariums and indoor theme parks fill whole days; shorter outings such as a dhow cruise, an abra ride on the Creek or the Burj Khalifa observation deck fit around nap times.",
            "For teenagers, add a jet ski or a sandboarding session; for small children, a gentle cruise or the aquarium is often the highlight."
          ]
        },
        {
          "h": "Family-friendly desert safaris",
          "p": [
            "A desert trip is a must for many families, but choose carefully: dune bashing is not recommended for very small children. Look for family or wildlife safaris with a camel ride, sandboarding and dinner at the camp, or a morning safari that skips the late evening."
          ]
        },
        {
          "h": "Tips for Dubai with kids",
          "p": [
            "Plan outdoor activities for the morning and late afternoon, and keep the middle of the day for indoor sights — especially from May to September. Private tours let you go at your own pace and often include child seats on request.",
            "Most activities have reduced child prices, and toddlers often go free. Check the age and height limits of each activity before booking; the list is ranked by reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is there to do in Dubai with toddlers?",
          "a": "Aquariums, gentle boat trips, beaches with calm water, indoor play areas and the observation decks. Avoid dune bashing and long outdoor tours in the heat."
        },
        {
          "q": "Is a desert safari OK for kids?",
          "a": "Yes, if you pick the right one: older children usually love dune bashing, while families with small children should choose a safari without it, or a wildlife safari focused on animals and the camp."
        },
        {
          "q": "Do children pay full price for tours in Dubai?",
          "a": "Usually not: most tours and attractions have child prices, and very young children often go free. The age bands differ between tours, so check them on each listing."
        },
        {
          "q": "When is the best time to visit Dubai with children?",
          "a": "From October to April, when the weather is warm but not too hot for beaches and outdoor activities. School holidays are busy, so book popular tickets early."
        }
      ]
    },
    "day-trips": {
      "title": "Abu Dhabi & Day Trips",
      "short": "Day Trips",
      "intro": "Abu Dhabi’s Sheikh Zayed Grand Mosque and Louvre, the mountains of Hatta, the fjords of Musandam — the trips worth a whole day away from Dubai.",
      "meta": "Abu Dhabi tours from Dubai: the Sheikh Zayed Grand Mosque, Louvre Abu Dhabi, Qasr Al Watan and Yas Island — plus day trips to Hatta and Musandam.",
      "seoTitle": "Abu Dhabi Tour from Dubai & Other Day Trips",
      "heading": "Abu Dhabi & Day Trips from Dubai",
      "guideTitle": "The best day trips from Dubai",
      "guide": [
        {
          "h": "An Abu Dhabi tour from Dubai",
          "p": [
            "The UAE’s capital is about 90 minutes by road and the most popular day trip from Dubai. A classic city tour picks you up at your hotel and starts at the Sheikh Zayed Grand Mosque — one of the largest mosques in the world, all white marble, gold and crystal chandeliers — then continues to the Louvre Abu Dhabi or Qasr Al Watan presidential palace, a drive along the Corniche and a stop at the Emirates Palace.",
            "Many tours add Yas Island, home of Ferrari World, Warner Bros. World and Yas Waterworld, either as a photo stop or with park tickets for the afternoon. A full Abu Dhabi day usually lasts 8 to 10 hours, door to door."
          ]
        },
        {
          "h": "Visiting the Grand Mosque",
          "p": [
            "Entry to the Sheikh Zayed Grand Mosque is free, but visitors need a time slot, which the tour arranges. The mosque welcomes visitors every day except Friday morning, when it opens only in the afternoon — tours plan around it.",
            "Dress modestly: long sleeves and long trousers or an ankle-length skirt, nothing tight or see-through, and a headscarf for women. Shoes come off inside the prayer halls. The Louvre Abu Dhabi is closed on Mondays, so tours on that day visit the palace instead."
          ]
        },
        {
          "h": "Hatta and the mountains",
          "p": [
            "Hatta, in the Hajar Mountains near the Oman border, is a change of scenery from the city: turquoise water at the dam, kayaking, mountain biking, hiking trails and a heritage village. It's about 90 minutes from Dubai and at its best in the cooler months."
          ]
        },
        {
          "h": "Musandam, Sharjah and the east coast",
          "p": [
            "Musandam in Oman is known for its fjords: dhow cruises among the cliffs, snorkelling and dolphins. It's a longer day with a border crossing, so bring your passport and check the visa rules for your nationality.",
            "Closer to Dubai, Sharjah has the region's best museums and heritage area; the east coast around Fujairah offers beaches, snorkelling and old forts."
          ]
        }
      ],
      "faq": [
        {
          "q": "How long does an Abu Dhabi tour from Dubai take?",
          "a": "A full day: usually 8 to 10 hours including the drive, about 90 minutes each way. Half-day tours cover the Grand Mosque and one more stop."
        },
        {
          "q": "What should I wear to the Sheikh Zayed Grand Mosque?",
          "a": "Clothes that cover arms and legs and are not tight or see-through, and a headscarf for women. If your clothes don’t meet the dress code, you can’t enter, so check before you leave."
        },
        {
          "q": "Is a day trip to Abu Dhabi from Dubai worth it?",
          "a": "Yes — the Sheikh Zayed Grand Mosque alone justifies the trip for most visitors, and a tour adds the Louvre Abu Dhabi or Yas Island in one day without having to drive."
        },
        {
          "q": "Do I need a passport for a day trip from Dubai?",
          "a": "Always for Musandam (Oman), where you cross a border. For trips within the UAE — Abu Dhabi, Hatta, Sharjah, Fujairah — carry your passport or ID anyway; some tours ask for it at hotel pickup."
        },
        {
          "q": "How long are day trips from Dubai?",
          "a": "Most take 8 to 10 hours including pickup and drop-off. Musandam trips are often longer, with an early start, because of the drive and the border crossing."
        },
        {
          "q": "Should I take a tour or drive myself?",
          "a": "Driving is easy on the UAE's highways, but a tour saves you parking and route planning, includes entry tickets and a guide, and is the simplest option for Musandam with its border formalities."
        }
      ]
    },
    "scenic-flights": {
      "title": "Scenic Flights",
      "short": "Scenic\nFlights",
      "intro": "A hot-air balloon drifting over the dunes at sunrise, or a helicopter sweeping past Burj Khalifa and the Palm — Dubai seen from the air.",
      "meta": "Hot air balloon rides over the Dubai desert at sunrise and helicopter tours over Burj Khalifa, the Palm and Dubai Marina — scenic flights in Dubai.",
      "seoTitle": "Hot Air Balloon & Helicopter Tours in Dubai",
      "heading": "Hot Air Balloon & Helicopter Rides in Dubai",
      "guideTitle": "Seeing Dubai from the air",
      "guide": [
        {
          "h": "Hot air balloon rides at sunrise",
          "p": [
            "Balloon flights take off over the desert at dawn, when the air is calmest, and float for about an hour above the dunes, with views of camels, gazelles and the Hajar Mountains on the horizon. Pickup is very early — usually between 4 and 5 am — and most packages include breakfast at a desert camp, and some a falconry show or a ride in a vintage Land Rover.",
            "Flights depend on the weather: if the wind is too strong, the operator cancels and offers another date or a refund."
          ]
        },
        {
          "h": "Helicopter tours over the city",
          "p": [
            "Helicopter tours start at about 12 minutes and follow the coast past the Burj Al Arab, Palm Jumeirah, Atlantis, Dubai Marina and Burj Khalifa. Longer flights add Dubai Creek, old Dubai and the World Islands.",
            "Window seats are allocated by the operator, often by weight; a private helicopter guarantees the view for your group."
          ]
        },
        {
          "h": "Which one to choose?",
          "p": [
            "A balloon ride is about the desert at sunrise — slow, quiet and a whole morning out. A helicopter shows the skyline and the coast in a few minutes and fits easily into a busy day. For the most photogenic light, choose an early-morning balloon or a late-afternoon helicopter. The list is ranked by reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "How much time does a hot air balloon ride in Dubai take?",
          "a": "Plan for the whole morning: pickup before dawn, about an hour in the air, then breakfast and activities at the camp, with drop-off at your hotel around late morning."
        },
        {
          "q": "Is there a minimum age for a balloon or helicopter ride?",
          "a": "Yes. Balloon operators usually accept children from about 5 years old and require them to be accompanied; helicopter tours accept younger children with an adult. Pregnant women usually can't fly in a balloon."
        },
        {
          "q": "What happens if the balloon flight is cancelled for weather?",
          "a": "The operator decides on the morning of the flight. If it's cancelled for wind or visibility, you're offered another date or a full refund."
        },
        {
          "q": "When is the best season for a hot air balloon ride in Dubai?",
          "a": "The cooler months, from October to April, are the most comfortable and have the most flights. In summer the season is reduced, with fewer departures."
        }
      ]
    },
    "hot-air-balloon": {
      "title": "Hot Air Balloon Rides",
      "intro": "Lift off over the desert at dawn and watch the sun rise over the dunes — a calm hour in the air, then breakfast at a desert camp.",
      "meta": "Hot air balloon rides in Dubai: sunrise flights over the desert dunes with hotel pickup, breakfast at a desert camp, falconry and camel rides.",
      "metaFrom": "Hot air balloon Dubai from {{price}}: sunrise flights over the desert dunes with hotel pickup, breakfast at a desert camp, falconry and camel rides.",
      "seoTitle": "Hot Air Balloon Dubai: Sunrise Desert Balloon Rides",
      "heading": "Hot Air Balloon Rides in Dubai",
      "guideTitle": "Planning a hot air balloon ride in Dubai",
      "guide": [
        {
          "h": "How the morning goes",
          "p": [
            "Balloon flights in Dubai take off over the desert outside the city at sunrise, when the air is calmest. Pickup from your hotel is very early — usually between 4 and 5 am — and the drive to the launch site takes about an hour. You watch the balloon being inflated, climb into the basket with the pilot and float for about an hour over the dunes, with the light changing from blue to gold.",
            "After the landing most packages continue on the ground: breakfast at a desert camp, often a falconry display, sometimes a camel ride or a drive in a vintage Land Rover. Expect to be back at your hotel by late morning."
          ]
        },
        {
          "h": "Standard, premium or private basket",
          "p": [
            "A standard flight shares a large basket with other guests, divided into compartments. Premium packages add a smaller group, a better breakfast or extras such as falconry and a desert drive; a private basket is booked for your group alone, which suits proposals and anniversaries.",
            "Some packages combine the flight with dune bashing or a quad bike ride, and a few fly from Ras Al Khaimah, about an hour further north. Each listing says what is included and whether hotel transfers are part of it."
          ]
        },
        {
          "h": "Weather, season and what to bring",
          "p": [
            "Balloons fly only in calm weather. The pilot decides on the morning itself; if wind or visibility rule out the flight, you are offered another date or a refund. The season runs mainly from October to April, with fewer flights in the summer months.",
            "Desert mornings are cool, even when the days are hot: bring a light jacket, wear closed shoes and keep your camera within reach. The list is ranked by traveller reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "How much does a hot air balloon ride in Dubai cost?",
          "a": "A seat in a shared basket with breakfast is the entry price; premium packages with a smaller basket, falconry or a desert drive cost more, and a private basket for your group the most. Each card shows the current price, per person."
        },
        {
          "q": "How long is a hot air balloon ride in Dubai?",
          "a": "About an hour in the air. With the early pickup, the inflation, breakfast and the drive back, the whole trip takes the morning — roughly from 4–5 am until late morning."
        },
        {
          "q": "What time does a balloon flight start?",
          "a": "At sunrise, so the time changes with the season. Hotel pickup is usually between 4 and 5 am; the operator confirms the exact time the day before."
        },
        {
          "q": "Can children fly in a hot air balloon?",
          "a": "Usually from 5 years old, on some flights from 7, always with an adult. Pregnant women and people with back or heart problems are advised not to fly — the listing gives the operator’s conditions."
        },
        {
          "q": "What happens if the flight is cancelled?",
          "a": "If the pilot cancels for wind or visibility, you are offered another date or a refund. That is why it is worth booking the balloon early in your trip, leaving a spare morning."
        },
        {
          "q": "Where do balloon flights in Dubai take off?",
          "a": "From the desert inland of Dubai, about an hour’s drive from the city. The launch site changes with the wind on the day, which is why the hotel pickup is part of the package. A few flights leave from Ras Al Khaimah, further north."
        },
        {
          "q": "Are there sunset balloon flights or flights over the city?",
          "a": "No: free-flying balloons take off only at sunrise, before the day’s heat stirs up the wind, and fly over the desert, away from the city. A balloon ride at the Palm or a cheap balloon ticket means a tethered balloon — a short ride up and down on a cable, not a desert flight."
        },
        {
          "q": "Is there a weight limit?",
          "a": "Yes, usually about 118–119 kg per passenger. Some operators charge a heavier passenger a second seat; check the listing before you book."
        }
      ]
    },
    "helicopter-tour": {
      "title": "Helicopter Tours",
      "intro": "See Palm Jumeirah, the Burj Al Arab and the Burj Khalifa from the air — a short flight along the coast, from 12 minutes up.",
      "meta": "Helicopter tours in Dubai: scenic flights from Atlantis The Palm over Palm Jumeirah, the Burj Al Arab, Dubai Marina and the Burj Khalifa, shared or private.",
      "metaFrom": "Helicopter tour Dubai from {{price}}: scenic flights from Atlantis The Palm over Palm Jumeirah, the Burj Al Arab, Dubai Marina and the Burj Khalifa, shared or private.",
      "seoTitle": "Helicopter Tour Dubai: Scenic Flights Over the City",
      "heading": "Helicopter Tours in Dubai",
      "guideTitle": "Planning a helicopter tour in Dubai",
      "guide": [
        {
          "h": "The routes and how long you fly",
          "p": [
            "Most helicopter tours in Dubai take off from the helipad at Atlantis The Palm, at the tip of Palm Jumeirah; others leave from a helipad in Jumeirah, near the Mall of the Emirates, or from the Jumeirah Beach Residence. The standard flight lasts 12 minutes: over the palm-shaped island, along the coast past the Burj Al Arab and on to the Burj Khalifa before turning back.",
            "Longer flights — 15, 17, 25 minutes and up to an hour, depending on the operator — add Dubai Marina, the World Islands, Sheikh Zayed Road and Dubai Creek, where the old city began. The minutes are the time in the air; with the check-in, the safety briefing and the transfer, plan on two to three hours."
          ]
        },
        {
          "h": "Shared or private, and the combos",
          "p": [
            "On a shared flight you sit with other guests, usually five or six to a helicopter, and the operator allocates the seats — often by weight, so a window seat isn’t guaranteed. A private flight is booked for your group alone and lets you choose the route and the time, which suits proposals, birthdays and photographers.",
            "Some packages combine the flight with an afternoon desert safari or with dinner at Atlantis The Palm; others add a hotel transfer both ways. Each listing says which helipad it leaves from, how long the flight is and what is included."
          ]
        },
        {
          "h": "What to know before you fly",
          "p": [
            "Bring your passport or Emirates ID: operators check it at the helipad, and without it you can’t board. Arrive 30 to 45 minutes early. Bags and loose items stay on the ground — the helipads have lockers — but phones and cameras are allowed on board.",
            "Flights are subject to the weather: if wind, dust or poor visibility ground the helicopter, you are offered another slot or a refund. The clearest air is in the cooler months, from October to April, and the late afternoon gives the warmest light over the skyline. The list is ranked by traveller reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "How long is a helicopter tour in Dubai?",
          "a": "The standard flight is 12 minutes in the air; longer routes run from about 15 minutes to an hour. With check-in, the safety briefing and transfers, the outing takes two to three hours."
        },
        {
          "q": "How much does a helicopter ride in Dubai cost?",
          "a": "The price follows the minutes in the air: the 12-minute flight over the Palm and the Burj Al Arab is the entry point, longer routes to the Burj Khalifa and the Creek cost more, and a private flight is priced for the whole helicopter. Each card shows the current price."
        },
        {
          "q": "Where do helicopter tours in Dubai take off?",
          "a": "Most from the helipad at Atlantis The Palm on Palm Jumeirah. Some operators fly from a helipad in Jumeirah near the Mall of the Emirates or from the Jumeirah Beach Residence — the listing names the starting point and whether hotel pickup is included."
        },
        {
          "q": "What do I need to bring?",
          "a": "Your original passport or Emirates ID — it is checked before boarding. Bags stay in a locker at the helipad; a phone or camera can come with you."
        },
        {
          "q": "Is there a weight limit?",
          "a": "Yes, usually about 110–113 kg per passenger. Passengers are weighed at check-in, and a heavier passenger may have to buy an extra seat."
        },
        {
          "q": "Can children fly on a helicopter tour?",
          "a": "Yes, from 2 years old with an adult — most operators don’t take children under 2, and adult prices usually apply from that age. Each passenger, children included, needs their own ID. The listing gives the operator’s conditions."
        },
        {
          "q": "Helicopter or hot air balloon?",
          "a": "A helicopter shows the skyline and the coast in a few minutes and fits into any day. A balloon floats over the desert at sunrise and takes the whole morning — see the hot air balloon rides."
        }
      ]
    },
    "quad-biking": {
      "title": "Quad Biking & Dune Buggies",
      "intro": "Take the wheel in the red dunes outside Dubai — a self-drive quad bike or dune buggy, on its own or as part of a desert safari.",
      "meta": "Quad biking and dune buggy tours in Dubai: self-drive rides in the red dunes, morning and evening desert safaris with quad bikes, camel rides and BBQ.",
      "metaFrom": "Quad biking and dune buggy Dubai from {{price}}: self-drive rides in the red dunes, morning and evening desert safaris with quad bikes, camel rides and BBQ.",
      "seoTitle": "Quad Bike & Dune Buggy Dubai: Self-Drive Desert Tours",
      "heading": "Quad Biking & Dune Buggy Tours in Dubai",
      "guideTitle": "Choosing a quad bike or buggy tour in Dubai",
      "guide": [
        {
          "h": "Quad bike or dune buggy?",
          "p": [
            "A quad bike (ATV) is a one-person machine you steer like a motorbike, with a thumb throttle — easy to learn and fun on the smaller dunes. A dune buggy is a car-like vehicle with a roll cage and seat belts, for two or four people; it climbs bigger dunes and suits couples and families who want to drive together.",
            "Both are self-drive: a guide leads the group along a marked route in the desert, adapting the pace to the least experienced driver. Helmets and goggles are provided."
          ]
        },
        {
          "h": "On its own or with a desert safari",
          "p": [
            "Many tours add a quad ride to a classic desert safari: dune bashing in a 4x4, a camel ride, sandboarding and, in the evening, a camp with BBQ dinner and live shows. Others are dedicated morning rides of 30 minutes to two hours, when the sand is cooler and the light softer.",
            "The rides take place in the red dunes south-east of the city, around Lahbab and Al Badayer, about 45 minutes from Dubai. Most tours include hotel pickup; the listing says how long you spend driving."
          ]
        },
        {
          "h": "Before you book",
          "p": [
            "Operators set a minimum age for drivers — often 16 for a quad and 18 for a buggy — and younger children can usually ride as passengers in a buggy. Wear closed shoes and comfortable clothes you don’t mind getting sandy, and bring a scarf against the dust.",
            "Morning rides are cooler and the best choice from May to September; in winter the evening safaris with a sunset stop are the most popular. The list is ranked by traveller reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "Do I need a driving licence for a quad bike in Dubai?",
          "a": "Usually not for a guided quad ride in the desert, but there is a minimum age, often 16. Buggy drivers are typically required to be 18 or over. The listing gives the operator’s conditions."
        },
        {
          "q": "What is the minimum age for quad biking in Dubai?",
          "a": "It depends on the operator: some let children drive a smaller quad from 10 to 13 with a guide, most set 16 for an adult quad, and buggy drivers are usually 18. Younger children can ride as passengers in a buggy. The listing gives the limit."
        },
        {
          "q": "How much does quad biking in Dubai cost?",
          "a": "A safari with a short quad session is the cheapest way; a dedicated hour on a quad or a buggy costs more, and a buggy is priced per vehicle. On many safari cards the quad is optional — check whether it is included or an extra."
        },
        {
          "q": "How long is the quad bike ride?",
          "a": "It depends on the tour: safari combos often include 20–30 minutes of driving, dedicated quad and buggy tours one or two hours. Check the duration in the listing."
        },
        {
          "q": "Is quad biking safe for beginners?",
          "a": "Yes, the routes are led by a guide, who explains the controls first and sets the pace. Helmets and goggles are provided. Beginners who prefer not to drive alone can choose a two-seat buggy."
        },
        {
          "q": "Morning or evening quad biking?",
          "a": "Mornings are cooler and quieter, best in the hot months. Evening rides are usually combined with a desert safari, sunset and dinner at a camp."
        },
        {
          "q": "Can I rent a quad bike and ride on my own?",
          "a": "You drive your own quad, but not alone: in the desert a guide always leads the group along the route. A private tour gives your group its own guide and pace."
        },
        {
          "q": "Where do you go quad biking in Dubai?",
          "a": "In the red dunes around Lahbab and Al Badayer, about 45 minutes south-east of the city. Most tours include the hotel pickup."
        }
      ]
    },
    "morning-desert-safari": {
      "title": "Morning Desert Safari",
      "intro": "Red dunes in the cool of the morning — dune bashing, sandboarding, a camel ride or a quad bike, and back in the city by early afternoon.",
      "meta": "Morning desert safari in Dubai: hotel pickup at dawn, dune bashing in the red dunes, sandboarding, camel rides and quad bikes, back by lunchtime.",
      "metaFrom": "Morning desert safari Dubai from {{price}}: hotel pickup at dawn, dune bashing in the red dunes, sandboarding, camel rides and quad bikes, back by lunchtime.",
      "seoTitle": "Morning Desert Safari Dubai: Dunes, Camels & Quads",
      "heading": "Morning Desert Safari in Dubai",
      "guideTitle": "Planning a morning desert safari",
      "guide": [
        {
          "h": "How the morning goes",
          "p": [
            "A morning safari starts with a hotel pickup around 7 or 8 am and a drive of about 45 minutes to the red dunes south-east of the city, around Lahbab. There the driver lets some air out of the tyres and takes the 4×4 up and over the dunes — dune bashing — with photo stops on the crests.",
            "Then come the activities: sandboarding down a dune, a short camel ride and, on many tours, a quad bike or dune buggy session you drive yourself. Most trips last three to five hours, so you are back at your hotel by lunchtime or early afternoon."
          ]
        },
        {
          "h": "Morning or evening?",
          "p": [
            "The morning is cooler, the dunes are quieter and the low sun brings out the ripples in the sand — the best light for photos after sunrise. It suits travellers with plans for the evening, families with young children who go to bed early, and anyone flying out at night.",
            "What the morning leaves out is the camp: no barbecue dinner, no fire or tanoura shows, no sunset. Some tours serve water and soft drinks, a few a light breakfast. A heritage safari in a vintage car to the Al Marmoom oasis is the gentle option, with less dune bashing and more wildlife."
          ]
        },
        {
          "h": "Practical tips",
          "p": [
            "Wear light, covering clothes and closed shoes, and bring sunglasses, sunscreen and a hat: the sand heats up fast once the sun is high. From May to September it is already hot by mid-morning, so take the earliest pickup; from October to April the morning is pleasant throughout.",
            "Dune bashing is bumpy and not for pregnant women or people with back or neck problems, and quad bikes have a minimum age — check the listing. Tours are shared or private; each listing says what is included, and the list is ranked by traveller reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "What time does a morning desert safari start?",
          "a": "Hotel pickup is usually between 7 and 8.30 am, earlier in summer. With the drive to the dunes and back, most tours end between 11 am and 1 pm."
        },
        {
          "q": "What is included in a morning desert safari?",
          "a": "Usually hotel pickup, dune bashing in a 4×4, sandboarding and a short camel ride, with water or soft drinks. Quad bikes or dune buggies are included in some tours and an extra in others; the listing says which."
        },
        {
          "q": "Is a morning or an evening desert safari better?",
          "a": "The morning is cooler, quieter and better for photos, and leaves your evening free. The evening adds the sunset and a camp with barbecue dinner and shows. Choose the morning for the dunes, the evening for the camp."
        },
        {
          "q": "Is a morning desert safari good for children?",
          "a": "Yes — it is shorter and cooler than the evening safari, and children enjoy the sandboarding and the camels. Dune bashing has an age limit on some tours and quad bikes usually start at 16; check the listing."
        },
        {
          "q": "Does the morning desert safari run in summer?",
          "a": "Yes, all year. From June to September take the earliest pickup: by mid-morning the sand is hot and the dunes are tiring. From October to April the whole morning is pleasant."
        },
        {
          "q": "Can I combine a morning safari with a hot air balloon?",
          "a": "Yes — some balloon packages continue after breakfast with dune bashing or a quad ride, so you get the sunrise flight and the dunes in one morning. They are listed with the hot air balloon rides."
        }
      ]
    },
    "burj-khalifa": {
      "title": "Burj Khalifa Tickets",
      "intro": "At the Top on levels 124 and 125, SKY on level 148 and The Lounge higher still — tickets for the world's tallest building, on their own or with a city tour.",
      "meta": "Burj Khalifa tickets: At the Top on levels 124–125, At the Top SKY on 148 and The Lounge on 152–154, plus combos with the Dubai Aquarium and city tours.",
      "seoTitle": "Burj Khalifa Tickets: At the Top, SKY & The Lounge",
      "heading": "Burj Khalifa Tickets & At the Top",
      "guideTitle": "Planning your visit to the Burj Khalifa",
      "guide": [
        {
          "h": "Which level to book",
          "p": [
            "The Burj Khalifa is 828 metres tall, and visitors can go up to three levels. At the Top, on levels 124 and 125, is the main observation deck: a 360-degree view over Downtown, the Gulf and the desert, with an open-air terrace on level 124. At the Top SKY, on level 148, is higher and quieter, with a guest lounge and smaller groups; its ticket includes levels 124 and 125 as well.",
            "The Lounge, on levels 152 to 154, is the highest of the three — a lounge with drinks and light food rather than a deck, and the most exclusive way up the tower."
          ]
        },
        {
          "h": "Sunset, daytime or night",
          "p": [
            "Tickets are sold for a time slot. The slots around sunset are the most popular — the city turns gold, then lights up — and they sell out first, often days ahead. Daytime gives the widest view of the coast and the desert when the air is clear; after dark you see the lights of Sheikh Zayed Road and the Marina.",
            "Plan about an hour to an hour and a half at the top, plus the security check and the queue for the lifts. Summer haze can soften the view; the clearest days are usually in winter."
          ]
        },
        {
          "h": "Getting there and combining it",
          "p": [
            "The entrance to At the Top is on the lower ground floor of The Dubai Mall, which a covered walkway links to the Burj Khalifa/Dubai Mall metro station. After your visit, the Dubai Fountain show plays on the lake below the tower in the evening.",
            "Many tickets come as combos — with the Dubai Aquarium & Underwater Zoo in the same mall, the Dubai Frame, the Miracle Garden, or a half-day or full-day city tour with hotel pickup. Each listing says which levels and extras are included. The list is ranked by traveller reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "Which Burj Khalifa ticket should I buy?",
          "a": "For most visitors, At the Top on levels 124 and 125 — the classic view, with the most time slots. At the Top SKY on level 148 is higher and less crowded; The Lounge on levels 152–154 adds drinks and the highest view open to visitors."
        },
        {
          "q": "When is the best time to go up the Burj Khalifa?",
          "a": "Just before sunset, if you can get a slot: you see the city by day, at sunset and lit up at night in one visit. Those slots sell out first, so book a few days ahead; the early morning is the quietest time."
        },
        {
          "q": "How long does a visit to At the Top take?",
          "a": "About an hour to an hour and a half at the top, plus the security check and the lifts — allow two hours in all. A combo with a city tour takes half a day or a full day."
        },
        {
          "q": "Where is the entrance to the Burj Khalifa?",
          "a": "On the lower ground floor of The Dubai Mall, signposted At the Top. By metro, get off at Burj Khalifa/Dubai Mall; tickets with hotel pickup take you to the entrance."
        }
      ]
    },
    "dubai-frame": {
      "title": "Dubai Frame Tickets",
      "intro": "A 150-metre picture frame in Zabeel Park with a glass-floored bridge at the top — old Dubai on one side, the new skyline on the other.",
      "meta": "Dubai Frame tickets: the glass-floor sky bridge 150 m above Zabeel Park, with hotel transfers or combos with Burj Khalifa, Miracle Garden and AYA Universe.",
      "seoTitle": "Dubai Frame Tickets: Glass Sky Bridge & Combos",
      "heading": "Dubai Frame Tickets",
      "guideTitle": "Planning your visit to the Dubai Frame",
      "guide": [
        {
          "h": "What you see",
          "p": [
            "The Dubai Frame stands 150 metres tall in Zabeel Park, between the old districts and the new city, shaped like a giant picture frame. A lift takes you up to the bridge that joins its two towers, where part of the floor is glass. To the north lie Deira, Bur Dubai and the Creek; to the south, Sheikh Zayed Road and the Burj Khalifa.",
            "The visit starts in a gallery about Dubai's past and ends in a short exhibition about the city's future, so it tells the story of Dubai as much as it shows it."
          ]
        },
        {
          "h": "When to go and how long",
          "p": [
            "Plan an hour to an hour and a half. Late afternoon is a good time: you see the city in daylight, then the lights come on as the sun goes down. The morning, just after opening, is the quietest.",
            "Entry is by time slot, and queues build at the lift at weekends and in the cooler months, the main season — booking ahead saves the wait."
          ]
        },
        {
          "h": "Tickets with transfers and combos",
          "p": [
            "The Frame is a fair walk from the nearest metro station, so many tickets include hotel pickup and drop-off. Others combine it with the Burj Khalifa, the Miracle Garden, Global Village or AYA Universe, or with an evening dhow cruise — a full day of sightseeing in one booking.",
            "The Miracle Garden and Global Village open only in the cooler months, roughly from autumn to spring, so their combos are seasonal. Each listing says what is included. The list is ranked by traveller reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "How tall is the Dubai Frame?",
          "a": "150 metres. The viewing bridge at the top joins its two towers and has a glass floor section you can walk across."
        },
        {
          "q": "How long does a visit to the Dubai Frame take?",
          "a": "About an hour to an hour and a half, with the gallery at the start, the bridge at the top and the exhibition on the way out."
        },
        {
          "q": "Burj Khalifa or Dubai Frame?",
          "a": "They show different things: the Burj Khalifa looks down on the whole city from much higher up, while the Frame puts old and new Dubai side by side from 150 metres — and is usually less crowded. Combo tickets let you do both in one day."
        },
        {
          "q": "How do I get to the Dubai Frame?",
          "a": "It stands in Zabeel Park, between Bur Dubai and Downtown. Take a taxi or a ticket with hotel transfers; from the nearest metro stations it is a walk of 15–20 minutes."
        }
      ]
    },
    "aquaventure": {
      "title": "Aquaventure Waterpark",
      "intro": "The water park of Atlantis The Palm: record-breaking slides through a shark lagoon, a long lazy river, a wave rider and a private beach.",
      "meta": "Aquaventure tickets at Atlantis The Palm: day passes for Dubai's biggest water park, with Lost Chambers Aquarium combos, hotel transfers and shark encounters.",
      "seoTitle": "Aquaventure Dubai Tickets: Atlantis Waterpark",
      "heading": "Aquaventure Waterpark Tickets",
      "guideTitle": "Planning a day at Aquaventure",
      "guide": [
        {
          "h": "What is in the park",
          "p": [
            "Aquaventure is the water park of Atlantis The Palm, at the outer tip of Palm Jumeirah, and one of the largest in the world, with more than 100 rides and attractions. The best known are the Leap of Faith, a near-vertical drop through a lagoon with sharks, Poseidon's Revenge and the Aquaconda, among the biggest water slides anywhere.",
            "Between the slides there is a long lazy river with rapids, a wave rider for surfing, splash areas for small children and a private beach, all part of the day pass."
          ]
        },
        {
          "h": "Day pass, combos and extras",
          "p": [
            "A day pass covers the slides, the river and the beach. Combo tickets add the Lost Chambers Aquarium at Atlantis, with its sunken-city tanks; others include hotel transfers, lunch, or a shark or dolphin encounter.",
            "A fast-track pass, lockers, towels and cabanas are usually extra. Each listing says what is included and which option you are booking."
          ]
        },
        {
          "h": "Tips for the day",
          "p": [
            "Plan a full day and arrive at opening, when the queues for the big slides are shortest. The park is open all year; on summer days the morning and late afternoon are the most comfortable hours.",
            "Some slides have height limits, so check them before promising a ride to children. The Palm Monorail ends at the Atlantis Aquaventure station, next to the park; tickets with transfers pick you up at your hotel. The list is ranked by traveller reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "Is the Lost Chambers Aquarium included in an Aquaventure ticket?",
          "a": "Not in a standard day pass — book a combo ticket for both. The listing says which option you are booking."
        },
        {
          "q": "How do I get to Aquaventure?",
          "a": "It is at Atlantis The Palm, at the end of Palm Jumeirah. The Palm Monorail runs to the Atlantis Aquaventure station; a taxi or a ticket with hotel transfers takes you to the entrance."
        },
        {
          "q": "Is Aquaventure good for small children?",
          "a": "Yes: there are splash areas and gentle slides for young children, and life jackets are available in the park. The big slides have height limits, so younger children may not be allowed on them."
        },
        {
          "q": "Is the beach included?",
          "a": "Yes, the day pass includes the park's private beach, so you can swim in the sea between the slides."
        }
      ]
    },
    "miracle-garden": {
      "title": "Miracle Garden Tickets",
      "intro": "The world’s largest natural flower garden — arches, castles and an Emirates A380 made of flowers. Open in the cooler months only.",
      "meta": "Dubai Miracle Garden tickets: entry with or without hotel transfer, and combos with the Dubai Frame, Burj Khalifa, Global Village and the Butterfly Garden.",
      "seoTitle": "Dubai Miracle Garden Tickets & Combos",
      "heading": "Dubai Miracle Garden Tickets",
      "guideTitle": "Planning a visit to Dubai Miracle Garden",
      "guide": [
        {
          "h": "What you see there",
          "p": [
            "Dubai Miracle Garden, in Dubailand, is the world’s largest natural flower garden: some 150 million flowers over 72,000 square metres, shaped into heart-shaped arches, umbrella-covered walkways, flower castles and life-size characters. Its best-known piece is a full-size Emirates A380 covered in flowers, listed by Guinness World Records.",
            "The displays are redesigned every season, so a second visit shows new themes. Paths are flat and partly shaded, with cafés, seating and toilets; two to three hours is enough to walk the whole garden."
          ]
        },
        {
          "h": "A seasonal garden",
          "p": [
            "The garden is outdoors and open in the cooler months only: it usually opens in autumn, around October or November, and closes when the summer heat comes, around May or June — the exact dates are announced each year. Out of season it is closed, so check the dates before booking.",
            "It opens daily from the morning until the evening, later at weekends. The late afternoon is the most comfortable time: cooler air, softer light for photos, and the garden lit up after sunset."
          ]
        },
        {
          "h": "Tickets, transfers and combos",
          "p": [
            "An entry ticket is all you need; many listings add a hotel transfer, which helps as there is no metro station next to the garden — by taxi it is about 20 to 30 minutes from Downtown or the Marina. Skip-the-line tickets save the queue at the gate on busy weekend evenings.",
            "About half the tickets are combos: the Butterfly Garden next door, the Dubai Frame, Burj Khalifa At the Top or an evening at Global Village, which is open in the same season. Each listing says what is included. The list is ranked by traveller reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "When is Dubai Miracle Garden open?",
          "a": "In the cooler months only: it usually opens around October or November and closes around May or June, with exact dates announced each season. It is open daily from the morning until the evening, later at weekends."
        },
        {
          "q": "How long do you need at Miracle Garden?",
          "a": "Two to three hours to walk the whole garden. With the Butterfly Garden next door, plan half a day."
        },
        {
          "q": "How do you get to Dubai Miracle Garden?",
          "a": "It is in Dubailand, about 20–30 minutes by taxi from Downtown or Dubai Marina, with no metro station nearby. Many tickets include a hotel transfer — the listing says whether it does."
        },
        {
          "q": "Is the Butterfly Garden included?",
          "a": "Not with a Miracle Garden ticket alone: it is a separate attraction next door. Combo tickets cover both — look for “Butterfly Garden” in the title."
        }
      ]
    },
    "global-village": {
      "title": "Global Village Dubai",
      "intro": "A seasonal open-air festival park of country pavilions, street food from around the world, stage shows and a funfair. Open in the cooler months, from late afternoon until late at night.",
      "meta": "Global Village Dubai: what to see, when it is open, how to get there, and entry tickets with hotel transfer or combined with the Miracle Garden.",
      "seoTitle": "Global Village Dubai: Visitor Guide & Tickets",
      "heading": "Global Village Dubai",
      "guideTitle": "Planning an evening at Global Village",
      "guide": [
        {
          "h": "What Global Village is",
          "p": [
            "Global Village is a large open-air festival park in Dubailand, on the edge of the city. Around thirty pavilions, each dressed in the architecture of a country or region, sell crafts, sweets, spices, textiles and souvenirs from some 90 cultures — from Turkey, India and Morocco to China, Africa and the Gulf.",
            "Between the pavilions are hundreds of food stalls and restaurants, a main stage and smaller stages with music and dance shows, a lake with performances on the water, and Carnaval, a funfair whose rides are paid for separately from entry. On weekend nights there are fireworks."
          ]
        },
        {
          "h": "When it is open",
          "p": [
            "Global Village is a winter attraction: each season usually opens in October and runs until around early May, with exact dates announced every year. In summer the park is closed.",
            "It opens in the late afternoon and stays open until around midnight, later at weekends. Most people arrive around sunset, when it is cooler and the pavilions light up; weekday evenings are noticeably less crowded than Friday and Saturday. Plan three to four hours — more if you want the rides and a sit-down dinner."
          ]
        },
        {
          "h": "Getting there and tickets",
          "p": [
            "The park is off Sheikh Mohammed Bin Zayed Road, about 25–30 minutes by taxi from Downtown and a little more from Dubai Marina. There is no metro station nearby; public buses run from several metro stations, and there is a large car park. Many listings below include a hotel transfer, which saves arranging the evening's taxis.",
            "Entry tickets come as cheaper weekday tickets and tickets valid any day; small children go in free. Rides, games and food are paid inside. The Miracle Garden, also in Dubailand and open in the same season, is a short drive away, so several listings combine the two in one afternoon and evening. Each listing says what is included; the list is ranked by traveller reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "When is Global Village open?",
          "a": "In the cooler months: a season usually runs from October to around early May, with dates announced each year. It opens daily from the late afternoon until around midnight, later at weekends."
        },
        {
          "q": "How long do you need at Global Village?",
          "a": "Three to four hours to walk the pavilions, eat and catch a show; half a day or more with the Carnaval rides."
        },
        {
          "q": "How do you get to Global Village?",
          "a": "It is in Dubailand, about 25–30 minutes by taxi from Downtown Dubai, with no metro station nearby. Public buses run from several metro stations, and many tickets include a hotel transfer — the listing says whether it does."
        },
        {
          "q": "Are the rides included in the entry ticket?",
          "a": "No. Entry covers the pavilions, the shows and the fireworks; the Carnaval rides and games are paid for separately inside the park."
        },
        {
          "q": "Can you visit Global Village and the Miracle Garden on the same day?",
          "a": "Yes: both are in Dubailand, a short drive apart, and open in the same season. Go to the Miracle Garden in the afternoon and to Global Village after sunset — combo tickets cover both."
        }
      ]
    },
    "ski-dubai": {
      "title": "Ski Dubai Tickets",
      "intro": "Real snow below zero inside a shopping mall — the snow park, a chairlift, the slope and a colony of penguins, open all year.",
      "meta": "Ski Dubai tickets: full-day Snow Park passes with winter clothing, chairlift and rides, the penguins and the indoor slope at Mall of the Emirates.",
      "seoTitle": "Ski Dubai Tickets: Snow Park & Indoor Slope",
      "heading": "Ski Dubai Tickets",
      "guideTitle": "Planning a day at Ski Dubai",
      "guide": [
        {
          "h": "Snow in the desert",
          "p": [
            "Ski Dubai is the indoor ski resort inside Mall of the Emirates — the first in the Middle East — kept at about −1 to −2 °C all year, with 6,000 tonnes of real snow. Its slope is about 400 metres long, served by a chairlift and a T-bar, with a freestyle zone of jumps and ramps.",
            "Most visitors come for the Snow Park beside it: tobogganing and tubing runs, a snow cavern, giant ball rides, the Mountain Thriller ride and snowball fights. It also has a colony of Gentoo and King penguins; the March of the Penguins, several times a day, is free for Snow Park guests."
          ]
        },
        {
          "h": "Which ticket to choose",
          "p": [
            "A Snow Park ticket gives full-day access to the park with winter clothing — jacket, trousers, boots and socks — and usually a chairlift ride and a Mountain Thriller ride. The Plus tickets add more rides, such as the Snow Bullet zip line above the slope. Skiing or snowboarding on the main slope needs a slope pass and the ability to turn and stop; beginners book a lesson first.",
            "Some listings add a private hotel transfer, others combine Ski Dubai with the Dubai Ice Rink or a hop-on hop-off bus. Each listing says which rides and gear are included. The list is ranked by traveller reviews."
          ]
        },
        {
          "h": "Practical tips",
          "p": [
            "Mall of the Emirates has its own station on the Red Line of the metro, so getting there is easy without a transfer. Gloves and a hat are not always part of the clothing — bring your own or buy them at the shop. Helmets are compulsory for children under 13 on the rides.",
            "Ski Dubai is open all year, from the morning until late in the evening, and is busiest at weekends and on summer afternoons, when it is the coolest place in town. Two to three hours in the Snow Park is enough for most families."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is included in a Ski Dubai ticket?",
          "a": "A Snow Park ticket includes full-day access to the park, winter clothing — jacket, trousers, boots and socks — and usually a chairlift ride and a Mountain Thriller ride. Plus tickets add more rides; the listing says exactly which."
        },
        {
          "q": "Do I need warm clothes for Ski Dubai?",
          "a": "No: the jacket, trousers, boots and socks are provided. Gloves and a hat are not always included, so bring your own or buy them there; wear long trousers and socks under the overalls."
        },
        {
          "q": "Can beginners ski at Ski Dubai?",
          "a": "In the Snow Park, anyone can toboggan and play in the snow. The main slope is for skiers and snowboarders who can turn and stop; beginners take a lesson first."
        },
        {
          "q": "Is Ski Dubai good for children?",
          "a": "Yes — the Snow Park, the rides and the penguins are made for families. Very young children may not be allowed on some rides, and helmets are compulsory under 13; check the listing for the age rules."
        }
      ]
    },
    "dubai-aquarium": {
      "title": "Dubai Aquarium Tickets",
      "intro": "Sharks and rays over your head in the glass tunnel, and penguins and otters in the zoo upstairs — inside The Dubai Mall, at the foot of the Burj Khalifa.",
      "meta": "Dubai Aquarium & Underwater Zoo tickets: the walk-through tunnel, the Underwater Zoo, Penguin Cove and combos with Burj Khalifa At the Top, in The Dubai Mall.",
      "seoTitle": "Dubai Aquarium Tickets: Tunnel & Underwater Zoo",
      "heading": "Dubai Aquarium Tickets",
      "guideTitle": "Planning a visit to the Dubai Aquarium",
      "guide": [
        {
          "h": "The tank, the tunnel and the zoo",
          "p": [
            "Dubai Aquarium & Underwater Zoo is on the ground floor of The Dubai Mall in Downtown Dubai. Its 10-million-litre tank holds thousands of animals — sand tiger sharks, rays, groupers and shoals of reef fish — behind one of the largest acrylic panels in the world. Part of the tank can be seen for free from the mall; the ticket takes you inside.",
            "Inside, a walk-through tunnel of about 48 metres runs under the tank, with the sharks and rays swimming over and around you. Upstairs, the Underwater Zoo has penguins, otters, a crocodile and the creatures of a rainforest and a rocky shore, with feeding times and keeper talks through the day."
          ]
        },
        {
          "h": "Which ticket to choose",
          "p": [
            "The basic ticket covers the tunnel and the Underwater Zoo. Penguin Cove tickets add the penguin area, and the Explorer tickets add more, such as a glass-bottom boat ride over the tank or a look behind the scenes. Shark dives and cage snorkelling are booked separately and have age and swimming rules.",
            "The Burj Khalifa is in the same mall, so many listings combine the aquarium with At the Top, often with a hotel transfer. Others include transport only. Each listing says which areas and extras are included. The list is ranked by traveller reviews."
          ]
        },
        {
          "h": "Practical tips",
          "p": [
            "The Burj Khalifa/Dubai Mall station on the Red Line of the metro is linked to the mall by an air-conditioned walkway. The aquarium is open every day from the morning until late in the evening; weekday mornings are the quietest, weekend afternoons the busiest.",
            "One to two hours is enough for the tunnel and the zoo; add an hour for a boat ride or an encounter. With a combo, book the Burj Khalifa slot first and visit the aquarium before or after it — the two entrances are a few minutes' walk apart."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is included in a Dubai Aquarium ticket?",
          "a": "The basic ticket includes the walk-through tunnel and the Underwater Zoo. Penguin Cove and Explorer tickets add the penguin area and extras such as a glass-bottom boat ride; the listing says exactly which."
        },
        {
          "q": "Can you see the Dubai Aquarium for free?",
          "a": "Part of the main tank can be seen through the big panel on the ground floor of The Dubai Mall without a ticket. The tunnel under the tank and the Underwater Zoo need one."
        },
        {
          "q": "How long does a visit to the Dubai Aquarium take?",
          "a": "Most visitors spend one to two hours in the tunnel and the zoo. A glass-bottom boat ride, a penguin encounter or a combo with the Burj Khalifa adds one to three hours."
        },
        {
          "q": "Is the Dubai Aquarium good for children?",
          "a": "Yes — the tunnel, the penguins and the otters are a favourite with families, and the visit is indoors and air-conditioned. Shark dives and some encounters have a minimum age; check the listing."
        }
      ]
    },
    "yas-island": {
      "title": "Yas Island Tickets",
      "intro": "Abu Dhabi's island of theme parks — Ferrari World, Warner Bros. World, Yas Waterworld and SeaWorld — as a day trip from Dubai.",
      "meta": "Yas Island tickets from Dubai: Ferrari World, Warner Bros. World Abu Dhabi, Yas Waterworld and multi-park passes, with hotel transfers or a city tour.",
      "seoTitle": "Yas Island Tickets: Ferrari World & Warner Bros",
      "heading": "Yas Island Theme Park Tickets",
      "guideTitle": "Planning a day on Yas Island",
      "guide": [
        {
          "h": "The parks",
          "p": [
            "Yas Island, on the edge of Abu Dhabi, gathers the country's biggest theme parks a few minutes apart. Ferrari World, under its huge red roof, is the home of Formula Rossa, one of the fastest roller coasters in the world, along with gentler rides and the history of the brand. Warner Bros. World is indoors too, with Looney Tunes and DC superheroes in themed lands such as Gotham City and Metropolis.",
            "Next to them are Yas Waterworld, an outdoor water park of slides and wave pools, SeaWorld Yas Island, a marine-life park with its rides and shows under one roof, and CLYMB, with indoor skydiving and a climbing wall. The Yas Marina Circuit hosts the Formula 1 Abu Dhabi Grand Prix at the end of the year."
          ]
        },
        {
          "h": "Which ticket to choose",
          "p": [
            "A single-park ticket covers one day in one park. Multi-park passes let you choose two or three parks over several days, which is worth it if you stay a night in Abu Dhabi or come back. Some listings let you pick the park when you book.",
            "From Dubai, many listings add a hotel transfer, and some combine the park with an Abu Dhabi city tour — the Sheikh Zayed Grand Mosque in the morning, a park in the afternoon. Each listing says which park, transport and stops are included. The list is ranked by traveller reviews."
          ]
        },
        {
          "h": "Practical tips",
          "p": [
            "Yas Island is about an hour and a half by road from Dubai, more at rush hour, so a park day is a full day: leave in the morning and arrive at opening time. Ferrari World, Warner Bros. World and SeaWorld are indoors and air-conditioned, which makes them a good choice in summer; Yas Waterworld is best from October to April or early in the day.",
            "The biggest rides have minimum heights and health rules — check them before you go if you travel with children. On a combo with the Grand Mosque, bring clothes that cover arms and legs, and a headscarf for women."
          ]
        }
      ],
      "faq": [
        {
          "q": "How far is Yas Island from Dubai?",
          "a": "About an hour and a half by road from central Dubai, a little less from Dubai Marina and Jebel Ali. Most listings include a hotel transfer both ways."
        },
        {
          "q": "Which park on Yas Island is best for children?",
          "a": "Warner Bros. World suits younger children best, with its cartoon characters and gentle rides. Ferrari World and Yas Waterworld have more thrill rides for teenagers; SeaWorld suits every age."
        },
        {
          "q": "Can you visit two parks in one day?",
          "a": "It is possible but tiring: each park easily fills a day. Multi-park passes are valid over several days, so most visitors spread them out."
        },
        {
          "q": "Are the Yas Island parks open in summer?",
          "a": "Yes — Ferrari World, Warner Bros. World and SeaWorld are indoors and air-conditioned all year. Yas Waterworld is outdoors; in summer go early, before the midday heat."
        }
      ]
    },
    "date-night": {
      "title": "Date Night",
      "short": "Date Night",
      "intro": "Sunset cruises, dinners with a view and evenings in the desert — ideas for a night out for two.",
      "meta": "Date night ideas in Dubai: sunset cruises, dinners with a view and romantic evenings in the desert."
    },
    "beach-days": {
      "title": "Beach Days",
      "short": "Beach Days",
      "intro": "Beach clubs, boat days and time on the water along Jumeirah, the Palm and the Marina.",
      "meta": "Beach days in Dubai: beach clubs, boat trips and water time along Jumeirah, the Palm and Dubai Marina."
    },
    "art-and-culture": {
      "title": "Art & Culture",
      "short": "Art & Culture",
      "intro": "Museums, galleries, heritage quarters and the stories behind the city's mosques and souks.",
      "meta": "Art and culture in Dubai: museums, galleries, heritage quarters, mosques and souks."
    },
    "luxury": {
      "title": "Luxury Experiences",
      "short": "Luxury Experiences",
      "intro": "Private yachts, helicopter flights and the city's most exclusive ways to spend a day.",
      "meta": "Luxury experiences in Dubai: private yacht charters, helicopter flights and exclusive tours."
    },
    "adventure": {
      "title": "Adventure & Outdoors",
      "short": "Adventure & Outdoors",
      "intro": "Skydiving over the Palm, hot-air balloons at dawn, ziplines and mountain hikes in Hatta.",
      "meta": "Adventure in Dubai: skydiving, hot-air balloon flights, ziplines, dune buggies and hiking in Hatta."
    },
    "downtown-dubai": {
      "title": "Downtown Dubai",
      "short": "Downtown",
      "intro": "The Burj Khalifa, The Dubai Mall and the fountain shows — the busiest square kilometres in the city.",
      "meta": "Things to do in Downtown Dubai: Burj Khalifa, The Dubai Mall, the Dubai Fountain and Dubai Opera."
    },
    "dubai-marina": {
      "title": "Dubai Marina",
      "short": "Dubai Marina",
      "intro": "A canal lined with towers: dhow dinner cruises among the lights, jet skis out to the Palm and the beach walk at JBR.",
      "meta": "Things to do in Dubai Marina: dhow dinner cruises along the canal, jet ski tours to the Palm and Burj Al Arab, JBR beach and city tours that stop here.",
      "seoTitle": "Things to Do in Dubai Marina: Cruises & Jet Skis",
      "heading": "Things to Do in Dubai Marina",
      "guideTitle": "Dubai Marina: what to know before you go",
      "guide": [
        {
          "h": "The Marina and JBR",
          "p": [
            "Dubai Marina is a canal about three kilometres long, cut into the coast and lined with residential towers, with a promenade, the Marina Walk, along both banks. On the seaward side lies JBR — Jumeirah Beach Residence — with a public beach and The Walk, a strip of cafés and shops at the foot of the towers. Bluewaters Island sits just offshore.",
            "After dark it is the liveliest part of new Dubai, and most of what you can book here happens on the water."
          ]
        },
        {
          "h": "Dinner cruises on the canal",
          "p": [
            "The Marina's dhow cruises are evening outings: about two hours along the canal on a wooden dhow or a modern glass-topped cruiser, with a buffet, music or a show on board and the towers lit up around you. Some leave the canal for a look back at the skyline from the sea.",
            "Compared with the Creek cruises of old Dubai, the Marina is the modern setting — skyscrapers instead of souks. Many listings include hotel transfers; each one says what is included, from drinks to the menu."
          ]
        },
        {
          "h": "Jet skis and the rest",
          "p": [
            "Jet ski tours start from the Marina and run along the coast to the Palm, Atlantis and the Burj Al Arab — from 30 minutes to two hours, with a guide on a second jet ski and usually no licence needed. Combined tours add a Marina cruise to a city tour or a desert safari, and at JBR an indoor blacklight minigolf makes an evening with children.",
            "Private yachts mostly leave from the Marina too; they have their own page, Yachts & Boats. The list here is ranked by traveller reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is there to do in Dubai Marina?",
          "a": "A dinner cruise along the canal, a jet ski tour out to the Palm and the Burj Al Arab, an evening on the Marina Walk or JBR's The Walk, and the beach at JBR by day."
        },
        {
          "q": "How long is a Dubai Marina dhow cruise?",
          "a": "Usually about two hours in the evening, with dinner on board. Where hotel pickup is included, it adds time before and after."
        },
        {
          "q": "Dubai Marina or Dubai Creek for a dhow cruise?",
          "a": "The Marina gives you modern skyscrapers and a livelier setting; the Creek in old Dubai is the traditional one, past the souks and the old trading dhows, and usually calmer. Both serve dinner on board."
        },
        {
          "q": "How do I get to Dubai Marina?",
          "a": "By metro, by the Dubai Tram, which runs through the Marina and along JBR, or by taxi. Many cruises and tours include hotel transfers."
        }
      ]
    },
    "palm-jumeirah": {
      "title": "Palm Jumeirah",
      "short": "Palm Jumeirah",
      "intro": "The palm-shaped island off Jumeirah: Aquaventure at Atlantis, the view from The Palm Tower, and jet skis and helicopters around the fronds.",
      "meta": "Things to do on Palm Jumeirah: Aquaventure tickets at Atlantis, The View at The Palm observation deck, jet ski tours and helicopter rides over the island.",
      "seoTitle": "Things to Do on Palm Jumeirah: Atlantis & The View",
      "heading": "Things to Do on Palm Jumeirah",
      "guideTitle": "Palm Jumeirah: what to know before you go",
      "guide": [
        {
          "h": "The island",
          "p": [
            "Palm Jumeirah is the man-made island shaped like a palm tree: a trunk running out to sea, sixteen fronds lined with villas, and a crescent around them that breaks the waves. Atlantis The Palm stands at the top of the crescent, with Atlantis The Royal close by.",
            "The shape only makes sense from above or from the water — which is what most of the tours here are about."
          ]
        },
        {
          "h": "Atlantis and Aquaventure",
          "p": [
            "Aquaventure, the water park at Atlantis, is the island's biggest draw: slides that run through shark lagoons, a long lazy river and a beach of its own — plan a full day. The aquarium inside the hotel and the shark encounters can be booked on their own.",
            "Tickets come with or without hotel transfers. Without them, take a taxi or the Palm Monorail, which runs along the trunk from the mainland to Atlantis."
          ]
        },
        {
          "h": "From above and from the water",
          "p": [
            "The View at The Palm is an observation deck on the 52nd floor of The Palm Tower, halfway along the trunk, about 240 metres up — the whole palm spreads out below you. Helicopter rides from the Atlantis area take you over the fronds, the Burj Al Arab and the Marina in as little as twelve minutes.",
            "Jet ski tours circle the crescent past Atlantis and the Burj Al Arab, mostly from the Marina next door. Boat trips around the island are on the Yachts & Boats page. The list here is ranked by traveller reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "What can you do on Palm Jumeirah?",
          "a": "Spend a day at the Aquaventure water park at Atlantis, see the island from The View at The Palm or from a helicopter, ride a jet ski around the crescent, or visit the aquarium at Atlantis."
        },
        {
          "q": "Where is the best view of Palm Jumeirah?",
          "a": "From above. The View at The Palm, on the 52nd floor of The Palm Tower, shows the whole shape of the island; a helicopter ride gives the postcard view from higher still."
        },
        {
          "q": "How long do you need at Aquaventure?",
          "a": "A full day: the slides, the lazy river and the beach easily fill six hours or more. In the warm months, arrive at opening — queues for the big slides build by midday."
        },
        {
          "q": "How do I get to Palm Jumeirah?",
          "a": "By taxi, or by the Palm Monorail, which runs along the trunk from the mainland to Atlantis. Many tickets include hotel transfers."
        }
      ]
    },
    "old-dubai": {
      "title": "Old Dubai & the Creek",
      "short": "Old Dubai",
      "intro": "Al Fahidi's wind towers, abra crossings and the gold and spice souks of Deira.",
      "meta": "Things to do in old Dubai: walking and city tours of Al Fahidi and the souks, abra rides across Dubai Creek and dhow dinner cruises on the Creek.",
      "seoTitle": "Old Dubai Tours: Creek, Souks & Al Fahidi",
      "heading": "Things to Do in Old Dubai",
      "guideTitle": "Old Dubai: what to know before you go",
      "guide": [
        {
          "h": "Both sides of the Creek",
          "p": [
            "Dubai Creek is the sea inlet the city grew up around. On its west bank, Bur Dubai holds the Al Fahidi quarter — lanes of restored coral-stone houses with wind towers, small museums and galleries — and the Textile Souk; across the water, Deira has the Gold Souk and the Spice Souk. Al Seef, a waterfront rebuilt in the old style, runs along the Bur Dubai side.",
            "This is where the walking tours and most classic city tours spend their time, before or after the Burj Khalifa and the beaches."
          ]
        },
        {
          "h": "Abras, souks and guided walks",
          "p": [
            "The abra, a small wooden water taxi, crosses the Creek in a few minutes and is part of almost every tour here. Guided walks cover Al Fahidi, the abra and the souks in two to four hours, some with tastings of Emirati food; half- and full-day city tours add photo stops in new Dubai.",
            "Go in the morning or late afternoon: the lanes have little shade at midday, and the souks are liveliest in the evening. Bargaining is normal in the souks; in the gold shops the weight of the piece sets most of the price."
          ]
        },
        {
          "h": "Dinner cruises on the Creek",
          "p": [
            "The Creek's dhow cruises are the traditional kind: about two hours in the evening on a wooden dhow, past the lit-up souks and the old trading boats, with a buffet and a show — often a tanoura dancer — on board. They are usually calmer than the cruises in the Marina.",
            "Some combo tours pair an old Dubai city tour with a desert safari or a Creek cruise over two or more days. The list is ranked by traveller reviews."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is there to do in old Dubai?",
          "a": "Walk the Al Fahidi quarter, cross the Creek by abra, browse the Gold and Spice Souks in Deira and end with a dinner cruise on the Creek — a full day on your own, or half a day with a guide."
        },
        {
          "q": "Where is old Dubai?",
          "a": "Around Dubai Creek, in the north of the city: Bur Dubai on the west bank, Deira on the east. It is 20–30 minutes from Downtown by taxi and on both metro lines."
        },
        {
          "q": "What should I wear in old Dubai?",
          "a": "Light clothes that cover the shoulders and knees — required to enter a mosque, and respectful in the old quarter and the souks. Wear comfortable shoes: the tours are mostly on foot."
        },
        {
          "q": "Is a dhow cruise on Dubai Creek worth it?",
          "a": "Yes, if you want the traditional side of Dubai: wooden dhows, the souks lit up along the banks and a calmer evening than in the Marina. Dinner is usually a buffet of Arabic and international dishes."
        }
      ]
    },
    "seeAlso": "See also:",
    "faqTitle": "Frequently Asked Questions",
    "boats": {
      "seoTitle": "Yacht Rental Dubai: Private Yacht & Boat Trips",
      "heading": "Private Yacht & Boat Trips in Dubai",
      "meta": "Rent a private yacht in Dubai by the hour: crewed cruises from Dubai Marina past JBR, Ain Dubai, Palm Jumeirah, Atlantis and the Burj Al Arab.",
      "guideTitle": "Choosing a private yacht trip in Dubai",
      "guide": [
        {
          "h": "How a private yacht trip works",
          "p": [
            "A private yacht trip in Dubai is a charter by the hour: the boat, its captain and crew are booked for your group alone, so there are no other passengers on board. Most trips last two to four hours; half-day and full-day charters suit groups that want to swim, sunbathe and take their time.",
            "The listing shows what the boat is — motorboat, motor yacht or catamaran — how long the trip lasts and what is included on board. You book on our partner's site, where the operator confirms the time and the details for your group."
          ]
        },
        {
          "h": "The classic route from Dubai Marina",
          "p": [
            "Nearly every trip leaves from Dubai Marina, one of the world's largest man-made marinas, lined with residential towers. From there the boat heads out past the beaches and promenade of JBR and Bluewaters Island with the Ain Dubai wheel, then along the outer crescent of Palm Jumeirah to Atlantis The Palm.",
            "Longer trips continue south to the Burj Al Arab, the sail-shaped hotel on its own island off Jumeirah Beach — the best-known photo stop of any cruise. On a two-hour trip the route usually ends at the Palm; three hours and more leave time to anchor for a swim."
          ]
        },
        {
          "h": "Sunset, party or celebration?",
          "p": [
            "Sunset and evening cruises are the most popular: the skyline turns gold, then lights up as you head back into the Marina. Daytime trips are the ones for swimming, a stop at the Palm and bright views of the coast.",
            "Many operators run themed trips — birthday and anniversary cruises, proposals, yacht parties with music, or a BBQ on board. Extras such as a jet ski, catering or decorations are usually booked on top, so check what the listing includes.",
            "The cooler months, roughly October to April, are the high season on the water. In summer, early morning and evening trips avoid the strongest heat."
          ]
        }
      ],
      "faq": [
        {
          "q": "How much does it cost to rent a yacht in Dubai?",
          "a": "Each listing shows a from-price for the whole trip; it depends on the size of the boat, the length of the trip and the season. Small motorboats for two hours are the most affordable, large motor yachts for a full day the most expensive. The operator confirms the final price for your group when you book."
        },
        {
          "q": "How long should a yacht trip in Dubai be?",
          "a": "Two hours is enough for the Marina, JBR, Ain Dubai and the Palm. Choose three or four hours to reach the Burj Al Arab and stop for a swim, and a half or full day if you want a relaxed day at sea."
        },
        {
          "q": "Is the yacht only for our group?",
          "a": "Yes. These are private charters: the boat and its crew are booked for your group, with no other passengers. How many guests a boat takes is stated in its listing."
        },
        {
          "q": "Can we swim during the trip?",
          "a": "On many longer trips the boat anchors near the Palm or off the beaches for a swim; the listing says whether swimming is part of the trip. Bring swimwear and sun protection."
        },
        {
          "q": "What is the best time for a yacht cruise in Dubai?",
          "a": "Late afternoon into sunset, when the light is softest and the skyline lights up on the way back. From October to April the weather is pleasant all day; in summer, morning and evening trips are cooler."
        },
        {
          "q": "Where do yacht trips in Dubai depart from?",
          "a": "Most leave from Dubai Marina; some from other marinas along the coast. The exact meeting point is confirmed by the operator after you book."
        }
      ]
    },
    "tours": {
      "seoTitle": "Dubai Tours & Excursions: Safaris, Cruises, Tickets",
      "heading": "Dubai Tours & Excursions",
      "meta": "Every tour in Dubai, ranked by reviews: desert safaris, city tours, dhow and yacht cruises, Burj Khalifa tickets, balloon flights and Abu Dhabi day trips.",
      "guideTitle": "How to choose a tour in Dubai",
      "guide": [
        {
          "h": "What kinds of tours there are",
          "p": [
            "Dubai's tours fall into a handful of groups. Desert safaris take you into the dunes outside the city for dune bashing, camel rides and dinner at a desert camp. City tours cover both sides of Dubai in a few hours: the old quarter along Dubai Creek with its souks and abra boats, and the new city of Downtown, the Palm and the Marina. Attraction tickets get you into Burj Khalifa, the Dubai Frame, the aquarium, Ski Dubai or the water parks, often with a fixed time slot.",
            "On the water there are dhow dinner cruises on the Creek and in the Marina, private yacht trips and water sports such as jet skis, parasailing and flyboarding. Hot-air balloon and helicopter flights show the desert and the skyline from above, and day trips take you beyond Dubai — most often to Abu Dhabi for the Sheikh Zayed Grand Mosque, the Louvre and the theme parks of Yas Island."
          ]
        },
        {
          "h": "Planning your days in Dubai",
          "p": [
            "Plan by the time of day. Mornings are the coolest time for walking tours and the old town, and the only time for balloon flights, which take off at sunrise. Midday is best spent indoors — at an observation deck, a museum, the aquarium or a mall. Late afternoon belongs to the desert safari, and evenings to dhow cruises, yacht trips at sunset and the lit-up skyline.",
            "Three to four days is enough for the classics: one day for Downtown and Burj Khalifa, one for old Dubai and the souks, one for the desert, and an evening on the water. A fifth day leaves time for Abu Dhabi or a beach day. From October to April the weather is pleasant for everything; in the summer months, choose morning and evening tours and air-conditioned attractions."
          ]
        },
        {
          "h": "Group, private or skip-the-line?",
          "p": [
            "Shared group tours are the most affordable way to see the city and the desert: you join other travellers in a vehicle or on a boat with a guide. Private tours cost more but run on your schedule, with a car, guide or boat only for your party — worth it for families, couples on a special occasion and anyone with a tight plan.",
            "For attractions, compare what the ticket includes: a time slot or open entry, the floors or areas you can visit, and whether a transfer from your hotel is part of the price. Many tours include hotel pickup in central Dubai; for areas further out, check the pickup zone on the listing."
          ]
        },
        {
          "h": "How this list works",
          "p": [
            "This page lists every tour and experience we have in Dubai, ranked by reviews: a tour with many good reviews comes before one with a perfect score from only a handful of guests. Use the search field to find a place or activity by name, or open a category for a shorter list with its own guide.",
            "You book on our partner's site — Viator for tours and tickets, Click&Boat for yacht trips — where you see the live price, the available dates and the cancellation policy before you pay. Many experiences can be cancelled free of charge up to 24 hours before the start."
          ]
        }
      ],
      "faq": [
        {
          "q": "What are the best tours in Dubai?",
          "a": "The tours travellers rate highest are the evening desert safari with a barbecue dinner, a Burj Khalifa ticket at sunset, a dhow dinner cruise, a walking tour of old Dubai with an abra ride across the Creek, and a private yacht trip past the Palm and the Burj Al Arab. This list puts the tours with the strongest reviews first."
        },
        {
          "q": "How many days do I need for tours in Dubai?",
          "a": "Three to four days cover the main sights: Downtown and Burj Khalifa, old Dubai and the souks, a desert safari and a cruise. Add a day for a trip to Abu Dhabi, a theme park or a hot-air balloon flight."
        },
        {
          "q": "Do Dubai tours include hotel pickup?",
          "a": "Most desert safaris, city tours and day trips include pickup and drop-off from hotels in central Dubai, such as Downtown, the Marina, JBR and Deira. Attraction tickets and cruises usually don't; the listing says what is included and which areas are covered."
        },
        {
          "q": "Is it better to book a private or a group tour?",
          "a": "Group tours are cheaper and a good way to meet other travellers. A private tour is worth the extra cost if you travel with children, want to set your own pace or have a special occasion: the vehicle, guide or boat is for your party alone."
        },
        {
          "q": "Can I book a tour in Dubai for the same day or tomorrow?",
          "a": "Often yes: many safaris, cruises and tickets can be booked a day ahead or even on the day, if places are left. In high season, from November to March, and on weekends and holidays, book a few days in advance."
        },
        {
          "q": "Are tours in Dubai available in German or Russian?",
          "a": "Most tours run in English. Some city tours and safaris are offered in other languages, including German and Russian; the language is stated in each tour's listing on the partner's site."
        }
      ]
    },
    "guides": {
      "guideTitle": "Planning your Dubai trip",
      "guide": [
        {
          "h": "When to visit Dubai",
          "p": [
            "The best time to visit Dubai is from November to March: days in the mid-20s °C, evenings cool enough to eat outside, and the season when outdoor favourites such as Global Village and the Miracle Garden are open. Desert safaris, dhow cruises and beach days are at their most comfortable then.",
            "April and October are warm shoulder months. From May to September the temperature passes 40 °C, so the day moves indoors — malls, water parks, Ski Dubai, the aquarium — and hotels are at their cheapest. Ramadan moves about eleven days earlier every year: attractions stay open, but hours change, so check the dates before you book."
          ]
        },
        {
          "h": "How many days you need",
          "p": [
            "Three days cover the essentials: Downtown with the Burj Khalifa and the fountain show, old Dubai along the Creek with an abra ride and the souks, and a desert safari. With five days add Palm Jumeirah and Dubai Marina, a beach day and a day trip to Abu Dhabi.",
            "A week leaves room for the theme parks — Dubai Parks and Resorts or Abu Dhabi's Yas Island — a balloon flight over the dunes or a yacht trip, and slower days. Our guides suggest day-by-day plans you can copy."
          ]
        },
        {
          "h": "Getting around and local tips",
          "p": [
            "The Metro links the airport, Deira, Downtown, Al Barsha and Dubai Marina; pay with a Nol card, which also works on buses and the Marina tram. Taxis and ride-hailing apps are easy for everything else. The weekend is Saturday and Sunday, and Friday afternoons are busy.",
            "Dress is relaxed on the beach and at the pool; in malls, the old town and mosques cover shoulders and knees. Alcohol is served in licensed hotels, bars and restaurants only. The dirham is pegged to the US dollar, and cards are accepted almost everywhere."
          ]
        },
        {
          "h": "How our Dubai guides work",
          "p": [
            "Each guide answers one planning question — when to go, where to take the kids, which desert safari to choose — and links to the tours, tickets and events listed on Dubai To-Do, so you can compare live prices and book from the page. We revise the guides as the catalogue and the city's calendar change."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is the best month to visit Dubai?",
          "a": "November to March, when days are warm rather than hot and the seasonal attractions are open. December and January are the busiest and most expensive; November, February and March are a good balance."
        },
        {
          "q": "How many days do you need in Dubai?",
          "a": "Four to five days is enough for Downtown, old Dubai, a desert safari, the Palm and Marina and a day trip to Abu Dhabi. Three days cover the highlights; a week leaves time for theme parks and the beach."
        },
        {
          "q": "Is Dubai safe for tourists?",
          "a": "Yes. Dubai has a very low crime rate and is easy to visit alone or with children. Respect local laws: public drunkenness, drugs and offensive behaviour are punished strictly."
        },
        {
          "q": "Do I need a visa for Dubai?",
          "a": "It depends on your passport: many nationalities get a free visa on arrival, others must apply in advance. Check the official UAE immigration sources for your nationality before you travel."
        },
        {
          "q": "What should tourists wear in Dubai?",
          "a": "Light, breathable clothes. Swimwear is fine on the beach and at the pool; in malls, the old town and mosques cover shoulders and knees, and bring a layer for the strong air-conditioning."
        }
      ]
    },
    "new-years-eve": {
      "title": "New Year's Eve in Dubai",
      "intro": "Gala dinners, beach-club parties, concerts and cruises for the last night of the year, and how to see the fireworks over the Burj Khalifa, the Palm and the Marina.",
      "meta": "NYE in Dubai: New Year's Eve parties, gala dinners, concerts and fireworks cruises, plus where to watch the Burj Khalifa fireworks, road closures and the metro.",
      "seoTitle": "NYE Dubai: New Year's Eve Events, Parties & Cruises",
      "heading": "New Year's Eve Events in Dubai",
      "eventsTitle": "Parties, gala dinners & concerts",
      "eventsOff": "The parties and gala dinners for the next New Year's Eve go on sale in the autumn and appear here as soon as they do. Until then, the guide below still holds.",
      "eventsOffLink": "See what's on in Dubai now",
      "toursTitle": "New Year's Eve cruises",
      "toursMore": "All yacht & boat trips",
      "guideTitle": "Planning New Year's Eve in Dubai",
      "guide": [
        {
          "h": "Parties, gala dinners and concerts",
          "p": [
            "Most of Dubai's New Year's Eve happens behind a ticket: hotel gala dinners with a set menu and a band, beach clubs with international DJs, concerts by Arabic stars and big-name performers, and countdown parties in rooftop bars. Many are timed so that guests can see one of the official fireworks displays at midnight — check whether the venue actually faces the Burj Khalifa, the Palm or the sea before you choose.",
            "Tickets usually include dinner or a drinks package; the price rises with the view. Venues serving alcohol are licensed, and most set an age limit of 21 for their parties."
          ]
        },
        {
          "h": "New Year's Eve on the water",
          "p": [
            "A cruise is the calmest way to see the fireworks: no crowds, no closed roads, and a seat for midnight. Dhows on Dubai Creek and in Business Bay sail towards the Burj Khalifa display, while yachts from Dubai Marina head out past JBR towards Atlantis and the Burj Al Arab.",
            "New Year cruises are longer than an ordinary evening trip and board well before midnight, so expect to be on the water from mid-evening until after the fireworks. A private yacht for a group is booked out first."
          ]
        },
        {
          "h": "Where to watch the fireworks",
          "p": [
            "The Burj Khalifa show in Downtown Dubai is the one the world watches, with fireworks and a light show on the tower; the area fills up from the afternoon, and parts of it are ticketed viewing zones. There are displays elsewhere too — around Atlantis The Palm and the Palm Jumeirah, at the Burj Al Arab, along JBR and Bluewaters, at the Dubai Frame and at Global Village. The official list for the coming night is announced in December.",
            "For a view without the Downtown crowds, watch from across the water: the Dubai Water Canal, Business Bay, a beach at JBR or a cruise."
          ]
        },
        {
          "h": "New Year's Eve with children",
          "p": [
            "Downtown at midnight is a long wait in a dense crowd — hard with small children. Global Village has held several countdowns through the evening for other countries' midnights, so a family can see fireworks well before bedtime; a dinner cruise or a hotel dinner facing a display is the other easy option.",
            "Family-friendly gala dinners exist, but many parties are adults only — check the age policy on the ticket page."
          ]
        },
        {
          "h": "Road closures and the metro",
          "p": [
            "Roads around the Burj Khalifa close from the afternoon of 31 December, and the parking in Downtown fills up early. The Dubai Metro usually runs through the night, but stations near the Burj Khalifa can close in the evening when the area is full — get off a stop earlier and walk, or arrive early.",
            "Taxis and ride-hailing apps are scarce right after midnight; plan to stay where you are for an hour or take the metro home."
          ]
        },
        {
          "h": "When to book",
          "p": [
            "The best-placed gala dinners, cruises and parties sell out in the first half of December, and prices only go up as the night gets closer. Book in November if you can — and check the cancellation terms, as many New Year's Eve tickets are non-refundable."
          ]
        }
      ],
      "faq": [
        {
          "q": "Where is the best place to watch the New Year's fireworks in Dubai?",
          "a": "The Burj Khalifa display in Downtown Dubai is the biggest, best seen from the Dubai Mall area, Burj Park or a restaurant facing the tower. For fewer crowds, watch from the water on a cruise, from Business Bay, or from the displays at the Palm, JBR or Global Village."
        },
        {
          "q": "Are the Burj Khalifa fireworks free to watch?",
          "a": "Watching from the public streets and promenades of Downtown is free, but they fill up hours before midnight and close when full. Some viewing areas near the tower have been ticketed in recent years, as are the restaurants, hotels and cruises with a view."
        },
        {
          "q": "What time should I get to Downtown Dubai on New Year's Eve?",
          "a": "In the afternoon or early evening: roads close from the afternoon and access to the area is stopped once it is full, often well before midnight."
        },
        {
          "q": "Does the Dubai Metro run on New Year's Eve?",
          "a": "Usually yes, through the night. Stations next to the Burj Khalifa may close in the evening because of the crowds, so plan to use a neighbouring station."
        },
        {
          "q": "Can I watch the fireworks from a boat?",
          "a": "Yes — dhow cruises and yachts take position on the water for midnight, the calmest way to see them. Book early: New Year cruises sell out."
        },
        {
          "q": "When should I book New Year's Eve in Dubai?",
          "a": "By November for the best choice; the popular gala dinners, parties and cruises sell out in December, and prices rise as the date gets closer."
        }
      ]
    },
    "hotels": {
      "title": "Where to stay",
      "seoTitle": "Where to Stay in Dubai: Best Areas & Hotel Map",
      "heading": "Where to stay in Dubai",
      "meta": "Where to stay in Dubai: Downtown, Business Bay, Dubai Marina, JBR, Palm Jumeirah, Jumeirah or Old Dubai — who each area suits, how to get around, and a map of hotels with prices for your dates.",
      "intro": "Dubai is long and narrow: some 40 km of coast from the Creek and the old town to the Marina, with the Burj Khalifa in between. Where you sleep decides whether your days start on a beach, in a mall or on the metro. Here is what each area is like, with a map of its hotels and prices for your dates from the main booking sites.",
      "guideTitle": "Booking a hotel in Dubai",
      "guide": [
        {
          "h": "Beach or city?",
          "p": [
            "Pick one base for the trip rather than moving between hotels. The beach areas — Dubai Marina, JBR, Palm Jumeirah and Jumeirah — suit a holiday built around the sea; Downtown and Business Bay suit a first visit with the sights, the malls and the fountain; Old Dubai suits a tighter budget and anyone who wants the souks and the Creek.",
            "Downtown and the Marina are about 25 km apart: 30 to 40 minutes by taxi outside rush hour, a little more on the metro’s Red Line, which links both with the airport."
          ]
        },
        {
          "h": "When to book",
          "p": [
            "November to March is high season — warm days, mild evenings — and prices peak around Christmas and New Year’s Eve, when the best-placed rooms go early. From June to September it is very hot and rooms are at their cheapest; resorts with pools and beach clubs make the most of it.",
            "Big events fill the city too: trade fairs, the Dubai Shopping Festival, Formula 1 weekend in Abu Dhabi. If your dates fall on one, book early."
          ]
        },
        {
          "h": "What the price includes",
          "p": [
            "Hotels in Dubai add a Tourism Dirham fee per room and night, paid at the hotel; booking sites usually show it apart from the room rate. Check whether breakfast is included and, at beach resorts, whether the beach and pools are free for guests.",
            "Apartments are common in the Marina, JBR and Downtown and pay off for families and longer stays: a kitchen, a washing machine, often a pool in the building."
          ]
        }
      ],
      "faq": [
        {
          "q": "What is the best area to stay in Dubai for a first visit?",
          "a": "Downtown Dubai: the Burj Khalifa, the Dubai Mall and the fountain are on the doorstep, the metro takes you to the old town and the Marina, and most tours pick up there. If the beach matters more than the sights, choose Dubai Marina or JBR."
        },
        {
          "q": "Where should I stay in Dubai for the beach?",
          "a": "JBR, where the hotels open onto a wide public beach and The Walk, or Palm Jumeirah, where most resorts have a beach of their own. Jumeirah, around the Burj Al Arab, is quieter, with resorts on long private beaches."
        },
        {
          "q": "Which area of Dubai is best for families?",
          "a": "Palm Jumeirah and JBR: beach resorts with kids’ clubs and pools, Aquaventure on the Palm and a flat beachfront promenade at JBR. An apartment in Dubai Marina is a good alternative for a longer stay."
        },
        {
          "q": "Where to stay in Dubai on a budget?",
          "a": "Old Dubai — Deira and Bur Dubai — has the most affordable hotels, close to the airport, the souks and the metro. Business Bay is a mid-range option within reach of Downtown."
        },
        {
          "q": "How do I get around between the areas?",
          "a": "The metro’s Red Line runs from the airport through Deira, Bur Dubai, Downtown and Business Bay to the Marina; a tram links the Marina, JBR and the Palm’s monorail. Taxis and ride-hailing apps are everywhere."
        },
        {
          "q": "Do you sell rooms?",
          "a": "No. The map and the “See hotels” buttons show offers from the main booking sites through our partner Stay22; you choose, book and pay on the booking site, under its own conditions. We may earn a commission when you book, at no extra cost to you."
        }
      ]
    }
  },
  "tours": {
    "intro": "Every tour and experience we list in Dubai, best reviewed first.",
    "searchLabel": "Search tours",
    "resultsFor": "Results for “{{query}}”",
    "noResults": "Nothing matches “{{query}}”.",
    "clearSearch": "Clear search",
    "showMore_one": "Show {{count}} more",
    "showMore_other": "Show {{count}} more"
  },
  "boats": {
    "intro": "Private yacht and boat trips in Dubai: the boat and its crew for your group only, from Dubai Marina past the Palm, Atlantis and the Burj Al Arab.",
    "typeLabel": {
      "Motorboat": "Motorboat",
      "Sailboat": "Sailboat",
      "Catamaran": "Catamaran",
      "RIB": "RIB",
      "Motor yacht": "Motor yacht",
      "Houseboat": "Houseboat",
      "Boat without licence": "Boat without a licence",
      "Jet ski": "Jet ski",
      "Sailing yacht": "Sailing yacht"
    },
    "fallbackTitle": "{{type}} {{name}} for rent in Dubai",
    "fallbackDescription": "{{type}} {{name}}, for rent by the day in Dubai.",
    "perDay": "/ day"
  },
  "empty": {
    "title": "Coming soon",
    "text": "We are lining up the first partners for this list. Until then, here are a few ideas to start with."
  },
  "card": {
    "tour": "Tours & Experiences",
    "boat": "Yachts & Cruises",
    "from": "from {{price}}",
    "reviews_one": "{{count}} review",
    "reviews_other": "{{count}} reviews"
  },
  "tourFacts": {
    "includedTitle": "What's included",
    "included": "Included",
    "excluded": "Not included",
    "meetingTitle": "Meeting & pickup",
    "knowBeforeTitle": "Know before you go",
    "private": "Private tour — only your group takes part",
    "shared_one": "Shared tour, up to {{count}} traveller",
    "shared_other": "Shared tour, up to {{count}} travellers",
    "languages": "Guide languages: {{languages}}",
    "pickupOptions": {
      "PICKUP_EVERYONE": "Pickup included for all travellers",
      "PICKUP_AND_MEET_AT_START_POINT": "Pickup offered, or meet at the starting point",
      "MEET_EVERYONE_AT_START_POINT": "Meet at the starting point (no pickup)"
    }
  },
  "detail": {
    "book": "Book now",
    "bookBoat": "Book now",
    "via": "via {{partner}}",
    "bookOn": "You’ll book on {{partner}}",
    "delisted": "This experience is no longer available.",
    "delistedBoat": "This boat is no longer available.",
    "duration": "Duration",
    "rating": "Rating",
    "price": "Price",
    "year": "Built",
    "more": "More experiences"
  },
  "footer": {
    "sisterSites": "Our other guides:",
    "about": "Tours, desert safaris, yacht charters and things to do across Dubai.",
    "thingsToDo": "Things to do",
    "areas": "Areas",
    "language": "Language",
    "disclosure": "© dubai-todo.com · An independent guide. Some links are affiliate links: when you book through our partners we may earn a commission, at no extra cost to you.",
    "tours": "Tours & excursions"
  },
  "notFound": {
    "title": "Page not found",
    "text": "The page you were looking for doesn't exist or has moved.",
    "home": "Go to Dubai To-Do"
  },
  "sample": {
    "dinner": {
      "category": "Tours & Experiences",
      "title": "Dinner with a View",
      "text": "Sunset dinners with unforgettable views across Dubai.",
      "place": "Downtown Dubai",
      "alt": "Terrace restaurant facing the Dubai skyline at dusk"
    },
    "safari": {
      "category": "Desert Experiences",
      "title": "Luxury Desert Safari",
      "text": "Extraordinary adventures beyond the city.",
      "place": "Dubai Desert Conservation Reserve",
      "alt": "Off-road vehicle crossing desert dunes at sunset"
    },
    "yacht": {
      "category": "Yachts & Cruises",
      "title": "Private Yacht Experience",
      "text": "Sail along Dubai’s coastline in total comfort.",
      "place": "Dubai Marina",
      "alt": "Motor yacht cruising in front of the Dubai skyline"
    }
  },
  "stub": {
    "saved": {
      "title": "Saved",
      "intro": "Keep the experiences you like in one place.",
      "text": "Saving experiences is coming soon. Until then, here are a few ideas to start with."
    },
    "account": {
      "title": "Account",
      "intro": "Your Dubai To-Do account.",
      "text": "Accounts are coming soon. Until then, here are a few ideas to start with."
    }
  },
  "events": {
    "metaTitle": "Events in Dubai — brunches, comedy, concerts & nightlife",
    "metaDescription": "What's on in Dubai: brunches, comedy nights, concerts, beach clubs and family shows, with dates, venues and tickets.",
    "title": "What's On in Dubai",
    "intro": "Brunches, comedy nights, concerts, beach-club days and family shows across Dubai in the coming months — the most popular first.",
    "empty": "Our events calendar for Dubai is being filled. Until then, here are a few ideas to start with.",
    "filters": {
      "when": "When",
      "category": "Type",
      "all": "All",
      "whens": {
        "any": "All dates",
        "today": "Today",
        "weekend": "This weekend",
        "week": "Next 7 days",
        "month": "Next 30 days"
      },
      "loading": "Loading…",
      "error": "Couldn't load these events. Please try again.",
      "none": "No events match these filters.",
      "count_one": "{{count}} event",
      "count_other": "{{count}} events"
    },
    "card": {
      "dateMore_one": "{{date}} + {{count}} more date",
      "dateMore_other": "{{date}} + {{count}} more dates"
    },
    "detail": {
      "next": "Next date",
      "dates": "Dates",
      "dateCount_one": "{{count}} date",
      "dateCount_other": "{{count}} dates",
      "venue": "Venue",
      "tickets": "Get tickets",
      "ended": "This event has ended.",
      "upcoming": "See upcoming events",
      "highlights": "Highlights",
      "datesTitle": "Dates & times",
      "soldOut": "sold out",
      "moreDates_one": "and {{count}} more date on the ticket page.",
      "moreDates_other": "and {{count}} more dates on the ticket page.",
      "venueTitle": "Venue",
      "map": "Map",
      "faqTitle": "Good to know",
      "related": "More events like this",
      "allEvents": "All events",
      "until": "Until {{date}}"
    },
    "categories": {
      "gastronomy": "Brunch & Dining",
      "parties": "Nightlife",
      "concerts": "Concerts & Music",
      "theatre": "Comedy & Shows",
      "family": "Kids & Family",
      "sport": "Sport",
      "festivals": "Festivals",
      "exhibitions": "Exhibitions & Culture",
      "cinema": "Cinema",
      "other": "Events"
    }
  },
  "guides": {
    "metaTitle": "Dubai Travel Guides — Tips, Itineraries & Things to Do",
    "metaDescription": "Dubai travel guides: when to go, itineraries, family tips, desert safaris and what to book — written around the tours and events on Dubai To-Do.",
    "title": "Dubai Guides",
    "intro": "Itineraries, family tips and practical advice for getting the most out of Dubai — with links to the tours and events we mention.",
    "empty": "Our first guides are being written. Until then, here are a few ideas to start with.",
    "badge": "Guide",
    "more": "More Dubai guides",
    "all": "All guides",
    "readAlso": "Read also",
    "readingTime_one": "{{count}} min read",
    "readingTime_other": "{{count}} min read",
    "topics": {
      "desert": "Desert & safaris",
      "food": "Food & drink",
      "seasonal": "Seasons",
      "boats": "Boats & beaches",
      "tours": "Tours & day trips",
      "culture": "Culture & sights",
      "shopping": "Shopping",
      "practical": "Practical tips"
    }
  },
  "hotels": {
    "eventHeading": "Staying the night?",
    "nearVenue": "Hotels near {{venue}}",
    "inCity": "Hotels in Dubai",
    "dates": "{{checkin}} → {{checkout}}",
    "cta": "See hotels",
    "ctaCity": "See hotels in Dubai",
    "showMap": "Show hotels on the map",
    "hideMap": "Hide the map",
    "mapTitle": "Map of hotels nearby",
    "sectionHeading": "Where to stay in Dubai",
    "sectionText": "Hotels, apartments and resorts across Dubai, with prices for your dates from the main booking sites.",
    "areasLink": "Which area to stay in"
  },
  "hotelsPage": {
    "chipsLabel": "Areas on the map",
    "all": "All of Dubai",
    "mapText": "Hotels, resorts and apartments across Dubai, with prices for your dates. The map loads from our partner Stay22.",
    "openMap": "Show the hotel map",
    "seeAll": "See hotels in Dubai",
    "areasTitle": "Dubai’s areas, one by one",
    "bestFor": "Best for",
    "showOnMap": "Show on the map",
    "areas": {
      "downtown": {
        "name": "Downtown Dubai",
        "bestFor": "a first visit, the sights, shopping",
        "p": [
          "The Burj Khalifa, the Dubai Mall and the Dubai Fountain stand in the middle of Downtown, and the hotels around them range from five-star towers to apartments in the residential blocks. Evenings are lively: the fountain shows, the mall’s restaurants, Souk Al Bahar.",
          "The Burj Khalifa / Dubai Mall metro station is on the Red Line, so the old town and the Marina are a ride away. What Downtown lacks is a beach: count 15 to 20 minutes by taxi to Jumeirah."
        ],
        "cta": "See hotels in Downtown",
        "thingsToDo": "Things to do in Downtown"
      },
      "business-bay": {
        "name": "Business Bay",
        "bestFor": "Downtown within reach, for less",
        "p": [
          "Towers of offices, hotels and apartments along Dubai Creek’s extension and the Water Canal, right next to Downtown: many hotels are a 10 to 15-minute walk or a short taxi ride from the Dubai Mall, often for less than Downtown itself.",
          "The canal promenade is pleasant in the evening, and Business Bay metro station is on the Red Line. Some blocks are still being built, so check where exactly your hotel stands."
        ],
        "cta": "See hotels in Business Bay"
      },
      "dubai-marina": {
        "name": "Dubai Marina",
        "bestFor": "restaurants, nightlife, the sea close by",
        "p": [
          "Towers around a canal full of yachts, with Marina Walk’s cafés and restaurants at their feet and the beach of JBR a few streets away. Many stays here are apartments — good for families and longer trips.",
          "The metro’s Red Line and the tram both stop in the Marina; Downtown is 30 to 40 minutes away. Yacht charters and the Marina’s dinner cruises leave from the doorstep."
        ],
        "cta": "See hotels in Dubai Marina",
        "thingsToDo": "Things to do in Dubai Marina"
      },
      "jbr": {
        "name": "JBR — Jumeirah Beach Residence",
        "bestFor": "the beach, straight from the hotel",
        "p": [
          "The beachfront strip next to the Marina: hotels and apartments look onto a wide public beach, with The Walk’s shops and restaurants behind it and Bluewaters Island across the bridge.",
          "It is the city’s liveliest beach, busy at weekends. The tram links JBR with the Marina’s metro stations."
        ],
        "cta": "See hotels at JBR"
      },
      "palm-jumeirah": {
        "name": "Palm Jumeirah",
        "bestFor": "beach resorts, families, a special trip",
        "p": [
          "The palm-shaped island holds many of Dubai’s big resorts — Atlantis The Palm at its tip, and hotels with private beaches along the fronds and the crescent. Many come with pools, kids’ clubs and restaurants enough to stay in all day.",
          "It is further from everything else: the monorail runs down the trunk to the Marina’s tram, and a taxi to Downtown takes 25 to 40 minutes."
        ],
        "cta": "See hotels on the Palm",
        "thingsToDo": "Things to do on Palm Jumeirah"
      },
      "jumeirah": {
        "name": "Jumeirah",
        "bestFor": "quiet resorts on the beach",
        "p": [
          "The coast between Downtown and the Marina: low-rise villas, public beaches and some of the city’s best-known resorts around the Burj Al Arab and Madinat Jumeirah, with its canals and souk.",
          "It is calm and green, halfway between the sights and the Marina — but there is no metro along the beach, so you will take taxis."
        ],
        "cta": "See hotels in Jumeirah"
      },
      "old-dubai": {
        "name": "Old Dubai — Deira & Bur Dubai",
        "bestFor": "a tighter budget, the souks, the airport close by",
        "p": [
          "The two banks of Dubai Creek, where the city began: the gold and spice souks in Deira, the Al Fahidi historical district in Bur Dubai, and the abras crossing between them for a coin. Hotels here are the most affordable in Dubai, and the airport is 10 to 15 minutes away.",
          "The metro serves both banks; Downtown is 15 to 20 minutes away, the beaches further. The streets are busy and traditional rather than glossy — which is the point."
        ],
        "cta": "See hotels in Old Dubai",
        "thingsToDo": "Things to do in Old Dubai"
      }
    }
  }
}
